(window.slate = window.slate || {}),
    (window.theme = window.theme || {}),
    (window.rfd = window.rfd || {}),
    (slate.a11y = {
        pageLinkFocus: function ($element) {
            var focusClass = "js-focus-hidden";
            $element.first().attr("tabIndex", "-1").focus().addClass(focusClass).one("blur", callback);
            function callback() {
                $element.first().removeClass(focusClass).removeAttr("tabindex");
            }
        },
        focusHash: function () {
            var hash = window.location.hash;
            hash && document.getElementById(hash.slice(1)) && this.pageLinkFocus($(hash));
        },
        bindInPageLinks: function () {
            $("a[href*=#]").on(
                "click",
                function (evt) {
                    this.pageLinkFocus($(evt.currentTarget.hash));
                }.bind(this)
            );
        },
        trapFocus: function (options) {
            var eventName = options.namespace ? "focusin." + options.namespace : "focusin";
            options.$elementToFocus || (options.$elementToFocus = options.$container),
                options.$container.attr("tabindex", "-1"),
                options.$elementToFocus.focus(),
                $(document).on(eventName, function (evt) {
                    options.$container[0] !== evt.target && !options.$container.has(evt.target).length && options.$container.focus();
                });
        },
        removeTrapFocus: function (options) {
            var eventName = options.namespace ? "focusin." + options.namespace : "focusin";
            options.$container && options.$container.length && options.$container.removeAttr("tabindex"), $(document).off(eventName);
        },
    }),
    (slate.cart = {
        cookiesEnabled: function () {
            var cookieEnabled = navigator.cookieEnabled;
            return cookieEnabled || ((document.cookie = "testcookie"), (cookieEnabled = document.cookie.indexOf("testcookie") !== -1)), cookieEnabled;
        },
    }),
    (slate.utils = {
        findInstance: function (array, key2, value) {
            for (var i = 0; i < array.length; i++) if (array[i][key2] === value) return array[i];
        },
        removeInstance: function (array, key2, value) {
            for (var i = array.length; i--; )
                if (array[i][key2] === value) {
                    array.splice(i, 1);
                    break;
                }
            return array;
        },
        compact: function (array) {
            for (var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = []; ++index < length; ) {
                var value = array[index];
                value && (result[resIndex++] = value);
            }
            return result;
        },
        defaultTo: function (value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        },
    }),
    (slate.rte = {
        wrapTable: function (options) {
            var tableWrapperClass = typeof options.tableWrapperClass > "u" ? "" : options.tableWrapperClass;
            options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
        },
        wrapIframe: function (options) {
            var iframeWrapperClass = typeof options.iframeWrapperClass > "u" ? "" : options.iframeWrapperClass;
            options.$iframes.each(function () {
                $(this).wrap('<div class="' + iframeWrapperClass + '"></div>'), (this.src = this.src);
            });
        },
    }),
    (slate.Sections = function () {
        (this.constructors = {}),
            (this.instances = []),
            $(document)
                .on("shopify:section:load", this._onSectionLoad.bind(this))
                .on("shopify:section:unload", this._onSectionUnload.bind(this))
                .on("shopify:section:select", this._onSelect.bind(this))
                .on("shopify:section:deselect", this._onDeselect.bind(this))
                .on("shopify:section:reorder", this._onReorder.bind(this))
                .on("shopify:block:select", this._onBlockSelect.bind(this))
                .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
    }),
    (slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
        _createInstance: function (container, constructor) {
            var $container = $(container),
                id = $container.attr("data-section-id"),
                type = $container.attr("data-section-type");
            if (((constructor = constructor || this.constructors[type]), !(typeof constructor > "u"))) {
                var instance = $.extend(new constructor(container), { id, type, container });
                this.instances.push(instance);
            }
        },
        _onSectionLoad: function (evt) {
            var container = $("[data-section-id]", evt.target)[0];
            container && this._createInstance(container);
        },
        _onSectionUnload: function (evt) {
            var instance = slate.utils.findInstance(this.instances, "id", evt.detail.sectionId);
            instance && (typeof instance.onUnload == "function" && instance.onUnload(evt), (this.instances = slate.utils.removeInstance(this.instances, "id", evt.detail.sectionId)));
        },
        _onSelect: function (evt) {
            var instance = slate.utils.findInstance(this.instances, "id", evt.detail.sectionId);
            instance && typeof instance.onSelect == "function" && instance.onSelect(evt);
        },
        _onDeselect: function (evt) {
            var instance = slate.utils.findInstance(this.instances, "id", evt.detail.sectionId);
            instance && typeof instance.onDeselect == "function" && instance.onDeselect(evt);
        },
        _onReorder: function (evt) {
            var instance = slate.utils.findInstance(this.instances, "id", evt.detail.sectionId);
            instance && typeof instance.onReorder == "function" && instance.onReorder(evt);
        },
        _onBlockSelect: function (evt) {
            var instance = slate.utils.findInstance(this.instances, "id", evt.detail.sectionId);
            instance && typeof instance.onBlockSelect == "function" && instance.onBlockSelect(evt);
        },
        _onBlockDeselect: function (evt) {
            var instance = slate.utils.findInstance(this.instances, "id", evt.detail.sectionId);
            instance && typeof instance.onBlockDeselect == "function" && instance.onBlockDeselect(evt);
        },
        register: function (type, constructor) {
            (this.constructors[type] = constructor),
                $("[data-section-type=" + type + "]").each(
                    function (index, container) {
                        this._createInstance(container, constructor);
                    }.bind(this)
                );
        },
    })),
    (slate.Currency = (function () {
        var moneyFormat = "${{amount}}";
        function formatMoney(cents, format) {
            typeof cents == "string" && (cents = cents.replace(".", ""));
            var value = "",
                placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
                formatString = format || moneyFormat;
            function formatWithDelimiters(number, precision, thousands, decimal) {
                if (((precision = slate.utils.defaultTo(precision, 2)), (thousands = slate.utils.defaultTo(thousands, ",")), (decimal = slate.utils.defaultTo(decimal, ".")), isNaN(number) || number == null)) return 0;
                number = (number / 100).toFixed(precision);
                var parts = number.split("."),
                    dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
                    centsAmount = parts[1] ? decimal + parts[1] : "";
                return dollarsAmount + centsAmount;
            }
            switch (formatString.match(placeholderRegex)[1]) {
                case "amount":
                    value = formatWithDelimiters(cents, 2);
                    break;
                case "amount_no_decimals":
                    value = formatWithDelimiters(cents, 0);
                    break;
                case "amount_with_comma_separator":
                    value = formatWithDelimiters(cents, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    value = formatWithDelimiters(cents, 0, ".", ",");
                    break;
            }
            return formatString.replace(placeholderRegex, value);
        }
        return { formatMoney };
    })()),
    (slate.Image = (function () {
        function preload(images, size) {
            typeof images == "string" && (images = [images]);
            for (var i = 0; i < images.length; i++) {
                var image = images[i];
                this.loadImage(this.getSizedImageUrl(image, size));
            }
        }
        function loadImage(path) {
            new Image().src = path;
        }
        function imageSize(src) {
            var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
            return match ? match[1] : null;
        }
        function getSizedImageUrl(src, size) {
            if (size === null) return src;
            if (size === "master") return this.removeProtocol(src);
            var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
            if (match) {
                var prefix = src.split(match[0]),
                    suffix = match[0];
                return this.removeProtocol(prefix[0] + "_" + size + suffix);
            } else return null;
        }
        function removeProtocol(path) {
            return path.replace(/http(s)?:/, "");
        }
        return { preload, loadImage, imageSize, getSizedImageUrl, removeProtocol };
    })()),
    (slate.Variants = (function () {
        function Variants(options) {
            (this.$container = options.$container),
                (this.product = options.product),
                (this.singleOptionSelector = options.singleOptionSelector),
                (this.originalSelectorId = options.originalSelectorId),
                (this.enableHistoryState = options.enableHistoryState),
                (this.currentVariant = this._getVariantFromOptions()),
                $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this)),
                setTimeout(
                    function () {
                        $(this.singleOptionSelector, this.$container).each(function (_, element) {
                            var $element = $(element),
                                type = $element.attr("type");
                            (type === "radio" || type === "checkbox") && $element[0].checked && $element.change();
                        });
                    }.bind(this)
                );
        }
        return (
            (Variants.prototype = $.extend({}, Variants.prototype, {
                _getCurrentOptions: function () {
                    var currentOptions = $.map($(this.singleOptionSelector, this.$container), function (element) {
                        var $element = $(element),
                            type = $element.attr("type"),
                            currentOption = {};
                        return type === "radio" || type === "checkbox"
                            ? $element[0].checked
                                ? ((currentOption.value = $element.val()), (currentOption.index = $element.data("index")), currentOption)
                                : !1
                            : ((currentOption.value = $element.val()), (currentOption.index = $element.data("index")), currentOption);
                    });
                    return (currentOptions = slate.utils.compact(currentOptions)), currentOptions;
                },
                _getVariantFromOptions: function () {
                    var selectedValues = this._getCurrentOptions(),
                        variants = this.product.variants,
                        found = !1;
                    return (
                        variants.forEach(function (variant) {
                            var satisfied = !0;
                            selectedValues.forEach(function (option) {
                                satisfied && (satisfied = option.value === variant[option.index]);
                            }),
                                satisfied && (found = variant);
                        }),
                        found || null
                    );
                },
                _onSelectChange: function () {
                    var variant = this._getVariantFromOptions();
                    this.$container.trigger({ type: "variantChange", variant }),
                        variant &&
                            (this._updateMasterSelect(variant),
                            this._updateImages(variant),
                            this._updatePrice(variant),
                            this._filterImages(variant),
                            (this.currentVariant = variant),
                            this.enableHistoryState && this._updateHistoryState(variant));
                },
                _filterImages: function (variant) {
                    const availableOptions = {};
                    if (
                        (this.product.variants.forEach((variant2) => {
                            variant2.available && (availableOptions[variant2.option1] = !0);
                        }),
                        Object.keys(availableOptions).length <= 1)
                    )
                        return;
                    const imageItems = document.querySelectorAll(".pdp-gallery__gallery-thumb"),
                        color_variant = variant.option1;
                    imageItems.forEach((item) => {
                        const image = item.querySelector("img");
                        image.alt.includes(color_variant) || (image.parentElement.style.display = "none");
                    });
                },
                _updateImages: function (variant) {
                    var variantImage = variant.featured_image || {},
                        currentVariantImage = this.currentVariant.featured_image || {};
                    !variant.featured_image || variantImage.src === currentVariantImage.src || this.$container.trigger({ type: "variantImageChange", variant });
                },
                _updatePrice: function (variant) {
                    (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) || this.$container.trigger({ type: "variantPriceChange", variant });
                },
                _updateHistoryState: function (variant) {
                    if (!(!history.replaceState || !variant)) {
                        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + variant.id;
                        window.history.replaceState({ path: newurl }, "", newurl);
                    }
                },
                _updateMasterSelect: function (variant) {
                    $(this.originalSelectorId, this.$container)[0].value = variant.id;
                },
            })),
            Variants
        );
    })()),
    (theme.Product = (function () {
        var selectors = {
            addToCart: "[data-add-to-cart]",
            addToCartText: "[data-add-to-cart-text]",
            preorderLineProperty: "[data-preorder-line-property]",
            peorderDateText: "[data-preorder-ship-dates]",
            comparePrice: "[data-compare-price]",
            comparePriceText: "[data-compare-text]",
            originalSelectorId: "[data-product-select]",
            priceWrapper: "[data-price-wrapper]",
            productFeaturedImage: "[data-product-featured-image]",
            productJson: "[data-product-json]",
            productPrice: "[data-product-price]",
            productThumbs: "[data-product-single-thumbnail]",
            singleOptionSelector: "[data-single-option-selector]",
        };
        function Product(container) {
            if (((this.$container = $(container)), !!$(selectors.productJson, this.$container).html())) {
                var sectionId = this.$container.attr("data-section-id");
                this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
                var options = {
                    $container: this.$container,
                    enableHistoryState: this.$container.data("enable-history-state") || !1,
                    singleOptionSelector: selectors.singleOptionSelector,
                    originalSelectorId: selectors.originalSelectorId,
                    product: this.productSingleObject,
                };
                (this.settings = {}),
                    (this.namespace = ".product"),
                    (this.variants = new slate.Variants(options)),
                    (this.$featuredImage = $(selectors.productFeaturedImage, this.$container)),
                    this.$container.on("variantChange" + this.namespace, this.updateAddToCartState.bind(this)),
                    this.$container.on("variantPriceChange" + this.namespace, this.updateProductPrices.bind(this)),
                    this.$featuredImage.length > 0 &&
                        ((this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr("src"))),
                        slate.Image.preload(this.productSingleObject.images, this.settings.imageSize),
                        this.$container.on("variantImageChange" + this.namespace, this.updateProductImage.bind(this)));
            }
        }
        return (
            (Product.prototype = $.extend({}, Product.prototype, {
                updateAddToCartState: function (evt) {
                    console.log("updateAddToCartState");
                    var variant = evt.variant,
                        product = this.productSingleObject;
                    if (variant) $(selectors.priceWrapper, this.$container).removeClass("hide");
                    else {
                        $(selectors.addToCart, this.$container).prop("disabled", !0), $(selectors.addToCartText, this.$container).html(theme.strings.unavailable), $(selectors.priceWrapper, this.$container).addClass("hide");
                        return;
                    }
                    if (variant.available)
                        if (($(selectors.addToCart, this.$container).prop("disabled", !1), product.tags.includes("flag: PREORDER"))) {
                            var preorderExceptions = product.tags.filter((str) => str.includes("flag: PREORDER-EX")),
                                exceptionsList = preorderExceptions.map(function (val) {
                                    return val.replace("flag: PREORDER-EX-", "");
                                });
                            if (exceptionsList.includes(variant.option2))
                                $(selectors.addToCartText, this.$container).html(theme.strings.addToCart), $(selectors.preorderLineProperty, this.$container).val(""), $(selectors.peorderDateText, this.$container).html("");
                            else {
                                $(selectors.preorderLineProperty, this.$container).val("This is a Preorder item"), $(selectors.addToCartText, this.$container).html("PREORDER");
                                var preorderDate = product.tags.filter((str) => str.includes("flag: PREORDER-D-"));
                                if (preorderDate.length) {
                                    var AdjustedDate = preorderDate.map(function (val) {
                                        return val.split("-");
                                    });
                                    $(selectors.peorderDateText, this.$container).html("ESTIMATED TO SHIP BETWEEN " + AdjustedDate[0][2] + " AND " + AdjustedDate[0][3]);
                                }
                            }
                        } else $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
                    else $(selectors.addToCart, this.$container).prop("disabled", !0), $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
                },
                updateProductPrices: function (evt) {
                    var variant = evt.variant,
                        $comparePrice = $(selectors.comparePrice, this.$container),
                        $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
                    $(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(variant.price, theme.moneyFormat)),
                        variant.compare_at_price > variant.price
                            ? ($comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat)), $compareEls.removeClass("hide"))
                            : ($comparePrice.html(""), $compareEls.addClass("hide"));
                },
                updateProductImage: function (evt) {
                    var variant = evt.variant,
                        sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
                    this.$featuredImage.attr("src", sizedImgUrl);
                },
                onUnload: function () {
                    this.$container.off(this.namespace);
                },
            })),
            Product
        );
    })()),
    (theme.customerAddresses = (function () {
        var $newAddressForm = $("#AddressNewForm");
        $newAddressForm.length &&
            (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", { hideElement: "AddressProvinceContainerNew" }),
            $(".address-country-option").each(function () {
                var formId = $(this).data("form-id"),
                    countrySelector = "AddressCountry_" + formId,
                    provinceSelector = "AddressProvince_" + formId,
                    containerSelector = "AddressProvinceContainer_" + formId;
                new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, { hideElement: containerSelector });
            }),
            $(".address-new-toggle").on("click", function (e) {
                e.preventDefault(), $newAddressForm.toggleClass("hide"), $newAddressForm.hasClass("hide") || $("html, body").animate({ scrollTop: $("body").offset().top }, "slow");
            }),
            $(".address-edit-toggle").on("click", function () {
                $(".edit-address").addClass("hide");
                var formId = $(this).data("form-id");
                $("#EditAddress_" + formId).toggleClass("hide");
            }),
            $(".address-delete").on("click", function () {
                var $el = $(this),
                    formId = $el.data("form-id"),
                    confirmMessage = $el.data("confirm-message");
                confirm(confirmMessage || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + formId, { parameters: { _method: "delete" } });
            }));
    })()),
    (theme.customerLogin = (function () {
        var config = { recoverPasswordForm: "#RecoverPassword", hideRecoverPasswordLink: "#HideRecoverPasswordLink" };
        if (!$(config.recoverPasswordForm).length) return;
        checkUrlHash(), resetPasswordSuccess(), $(config.recoverPasswordForm).on("click", onShowHidePasswordForm), $(config.hideRecoverPasswordLink).on("click", onShowHidePasswordForm);
        function onShowHidePasswordForm(evt) {
            evt.preventDefault(), toggleRecoverPasswordForm();
        }
        function checkUrlHash() {
            var hash = window.location.hash;
            hash === "#recover" && toggleRecoverPasswordForm();
        }
        function toggleRecoverPasswordForm() {
            $("#RecoverPasswordForm").toggleClass("hide"), $("#CustomerLoginForm").toggleClass("hide");
        }
        function resetPasswordSuccess() {
            var $formState = $(".reset-password-success");
            $formState.length && $("#ResetSuccess").removeClass("hide");
        }
    })()),
    (function () {
        "use strict";
        var selectors = { main: "body", contain: "[data-scroll-contain]" },
            NO_SCROLL_CLASS = "no-scroll",
            scrollPosition = 0,
            stickySelector = ".sticky-container",
            stickyFixedClass = "is-fixed",
            stickyMq = "only screen and (min-width: 990px)";
        function toggleStickyPositions(toggle) {
            var $stickies = $(stickySelector);
            if (!(!$stickies.length || $stickies.get(0).style.position !== "")) {
                if (!toggle) {
                    $stickies.each(function () {
                        $(this).removeClass(stickyFixedClass).css({ position: "", left: "", top: "" });
                    });
                    return;
                }
                window.matchMedia(stickyMq).matches &&
                    $stickies.each(function () {
                        var offset = $(this).offset(),
                            offsetTopViewport = offset.top - $(document).scrollTop(),
                            offsetLeftViewport = offset.left - $(document).scrollLeft(),
                            width = $(this).outerWidth(!0);
                        $(this).addClass(stickyFixedClass).css({ left: offsetLeftViewport, top: offsetTopViewport, width });
                    });
            }
        }
        function apply() {
            console.log("noscroll apply"), toggleStickyPositions(!0), (scrollPosition = window.pageYOffset), $("body").addClass(NO_SCROLL_CLASS), $(selectors.main).css({ top: -scrollPosition + "px", position: "relative" });
        }
        function remove() {
            console.log("noscroll remove"), toggleStickyPositions(!1), $("body").removeClass(NO_SCROLL_CLASS), $(selectors.main).css({ top: "", position: "" }), window.scrollTo(0, scrollPosition);
        }
        function contain(overlayEl) {
            var yPosition = null;
            overlayEl.addEventListener(
                "touchstart",
                function (event) {
                    event.targetTouches.length === 1 && (yPosition = event.targetTouches[0].clientY);
                },
                !1
            );
            function isOverlayTotallyScrolled() {
                return overlayEl.scrollHeight - overlayEl.scrollTop <= overlayEl.clientHeight;
            }
            function disableRubberBand(event) {
                var clientY = event.targetTouches[0].clientY - yPosition;
                overlayEl.scrollTop === 0 && clientY > 0 && event.preventDefault(), isOverlayTotallyScrolled() && clientY < 0 && event.preventDefault();
            }
            overlayEl.addEventListener(
                "touchmove",
                function (event) {
                    event.targetTouches.length === 1 && disableRubberBand(event);
                },
                !1
            );
        }
        function containScrollers() {
            $(selectors.contain).each(function () {
                contain(this);
            });
        }
        function init() {
            containScrollers();
        }
        init(), (window.rfd = window.rfd || {}), (window.rfd.noscroll = {}), (window.rfd.noscroll.apply = apply), (window.rfd.noscroll.remove = remove), (window.rfd.noscroll.contain = contain);
    })(),
    (function () {
        "use strict";
        var $menus = $(".off-canvas"),
            DIMMER_TRANS_LENGTH = 700;
        if (!$menus.length) return;
        function dimmerHide() {
            $(".off-canvas__dimmer").addClass("hide");
        }
        function dimmerShow() {
            $(".off-canvas__dimmer").removeClass("hide");
        }
        function afterClose() {
            dimmerHide();
        }
        function closeMenu(menu) {
            var $fullscreenCarousels;
            document.querySelector(".site-header__basket").focus(),
                window.rfd && window.rfd.noscroll && window.rfd.noscroll.remove(),
                $(menu).attr("aria-hidden", !0),
                $("body").removeClass("is-offcanvas-open is-offcanvas-push-left is-offcanvas-push-right"),
                setTimeout(afterClose, DIMMER_TRANS_LENGTH);
        }
        function closeAllMenus() {
            $menus.filter('[aria-hidden="false"]').each(function (i, menu) {
                closeMenu(menu);
            });
        }
        function afterOpen() {
            document.querySelector(".minicart__header .btn--close").focus();
        }
        function openMenu(menu) {
            var $fullscreenCarousels, isOpenClass, $sliders, $focusEl;
            $(menu).attr("aria-hidden") !== "false" &&
                (window.rfd && window.rfd.noscroll && window.rfd.noscroll.apply(),
                typeof ReloadSmartWishlist < "u" && $.isFunction(ReloadSmartWishlist) && ReloadSmartWishlist(),
                dimmerShow(),
                (isOpenClass = "is-offcanvas-open"),
                $(menu).is(".off-canvas--push") &&
                    ((isOpenClass += " is-offcanvas-push"), $(menu).is(".off-canvas--right") && (isOpenClass += " is-offcanvas-push-right"), $(menu).is(".off-canvas--small") && (isOpenClass += " is-offcanvas-small")),
                setTimeout(function () {
                    $(menu).attr("aria-hidden", !1), $("body").addClass(isOpenClass), setTimeout(afterOpen, DIMMER_TRANS_LENGTH);
                }, 0),
                ($focusEl = $(".minicart__header .btn--close").find(".js-first-focus").first()),
                $focusEl.length || ($focusEl = $(menu).find("input, select, textarea").first()),
                $focusEl.length || ($focusEl = $(menu).find("a.is-active").first()),
                $focusEl.length || ($focusEl = $(menu).find("a").first()),
                ($sliders = $(menu).find(".slick-initialized.slick-slider")),
                $sliders.length && $sliders.slick && (console.log("Slick init"), $sliders.find(".slick-arrow").remove(), $sliders.slick("reinit")));
        }
        function toggleMenu(menu) {
            var isClosed = $(menu).attr("aria-hidden") === "true";
            isClosed ? (closeAllMenus(), openMenu(menu)) : closeMenu(menu);
        }
        function addDimmer() {
            var $dimmer = $('<div class="off-canvas__dimmer" />');
            $("body").append($dimmer),
                $dimmer.on("click", function () {
                    closeAllMenus();
                });
        }
        function initControls() {
            $menus.each(function (index, menu) {
                var thisId = $(menu).attr("id"),
                    $menuToggles = $('a[href="#' + thisId + '"]');
                $menuToggles.on("click", function (e) {
                    e.preventDefault(), toggleMenu(menu);
                }),
                    $(menu).on("click", ".js-offcanvas-close", function (e) {
                        e.preventDefault(), closeMenu(menu);
                    });
            });
        }
        function init() {
            addDimmer(), initControls();
        }
        init(), (window.rfd = window.rfd || {}), (window.rfd.closeAllMenus = closeAllMenus), (window.rfd.closeMenu = closeMenu), (window.rfd.openMenu = openMenu), (window.rfd.toggleMenu = toggleMenu);
    })(),
    (function () {
        "use strict";
        var TRANS_LENGTH = 400,
            selectors = { modal: "[data-modal]", modalInner: ".modal__inner", closeBtn: ".js-modal-close", bodyClassOpen: "is-modal-open" },
            $modals;
        function close(modal) {
            window.rfd && window.rfd.noscroll && window.rfd.noscroll.remove(),
                $("body").removeClass(selectors.bodyClassOpen),
                $(modal).attr("aria-hidden", !0),
                setTimeout(function () {
                    $(modal).addClass("hide");
                }, TRANS_LENGTH);
        }
        function closeAll() {
            $modals.filter('[aria-hidden="false"]').each(function (i, menu) {
                close(menu);
            });
        }
        function open(modal) {
            var $focusEl = $(modal).find(".js-first-focus").first();
            $(modal).attr("aria-hidden") !== "false" &&
                (window.rfd && window.rfd.noscroll && window.rfd.noscroll.apply(),
                $(modal).removeClass("hide"),
                $(modal).attr("aria-hidden", !1),
                setTimeout(function () {
                    $("body").addClass(selectors.bodyClassOpen);
                }, 0),
                $focusEl.length || ($focusEl = $(modal).find("input, select, textarea, button").first()),
                $focusEl.length || ($focusEl = $(modal).find("a.is-active").first()),
                $focusEl.length || ($focusEl = $(modal).find("a").first()));
        }
        function toggle(modal) {
            var isClosed = $(modal).attr("aria-hidden") === "true";
            isClosed ? (closeAll(), open(modal)) : close(modal);
        }
        function initControls() {
            console.debug("[rfd.modal] initControls", { $modals }),
                $modals.each(function (index, modal) {
                    var thisId = $(modal).attr("id"),
                        $modalToggles = $('a[href="#' + thisId + '"]'),
                        $modalCloseBtns = $(modal).find(selectors.closeBtn),
                        $modalInner = $(modal).find(selectors.modalInner);
                    $(modal).on("click", function () {
                        close(modal);
                    }),
                        $modalInner.on("click", function (e) {
                            e.stopPropagation();
                        }),
                        $modalToggles.on("click", function (e) {
                            e.preventDefault(), toggle(modal);
                        }),
                        $modalCloseBtns.on("click", function (e) {
                            e.preventDefault(), close(modal);
                        });
                });
        }
        function showAlert(title, desc) {
            var $globalErr = $("#global-error");
            $globalErr.length || console.error("No alert HTML in DOM to display error:"),
                title && (title == "Cart Error" && (title = "Oops!"), $globalErr.find(".modal__title").html("<h3>" + title + "</h3>")),
                desc && $globalErr.find(".modal__body").html("<p>" + desc + "</p>"),
                open($globalErr),
                console.info("Alert:", title, desc);
        }
        function _init() {
            console.debug("[rfd.modal] _init"),
                ($modals = $(selectors.modal)),
                console.debug("[rfd.modal] _init", { selectors, $modals }),
                $modals.length &&
                    (initControls(),
                    $modals.each(function () {
                        window.rfd && window.rfd.noscroll && window.rfd.noscroll.contain(this);
                    }));
        }
        _init(), (window.rfd.modal = {}), (window.rfd.modal.closeAll = closeAll), (window.rfd.modal.close = close), (window.rfd.modal.open = open), (window.rfd.modal.toggle = toggle), (window.rfd.alert = showAlert);
    })(),
    (function () {
        "use strict";
        var selectors = { control: "[data-ajax-ctrl]", controlTxt: "[data-ctrl-text]", activeControl: "[data-ajax-ctrl-active]", alwaysTxtChange: "[data-show-ajax-status]", cartCount: "[data-cart-item-count]" },
            $controls = null;
        (window.rfd = window.rfd || {}), (window.rfd.ajaxControlsDisabled = !1);
        function handleRequestComplete(event, cart) {
            $(selectors.cartCount).html(cart.item_count);
        }
        function disable(activeBtn, loadStr, $customBtns) {
            var loadString = loadStr || theme.strings.addToCartProgress,
                $sliders;
            if (window.rfd.ajaxControlsDisabled === !0) {
                console.log("[ajax-utils] controls already disabled");
                return;
            }
            activeBtn && $(activeBtn).attr("data-ajax-ctrl-active", !0),
                !$customBtns || !$customBtns.length ? ($controls = $(selectors.control).filter(":not([disabled])")) : ($controls = $customBtns),
                $controls.attr("disabled", "disabled"),
                ($sliders = $controls.filter(".range-slider")),
                $sliders.siblings(".irs").attr("disabled", "disabled"),
                $controls.each(function (i, el) {
                    var $txt = $(el).find(selectors.controlTxt);
                    (!$(el).is(selectors.alwaysTxtChange) && !$(el).is(selectors.activeControl)) || ($txt.length && ($txt.data("orig-text", $txt.text()), $txt.text(loadString)));
                }),
                (window.rfd.ajaxControlsDisabled = !0),
                console.log("[ajax-utils] disable controls");
        }
        function enable() {
            var $sliders;
            if (window.rfd.ajaxControlsDisabled === !1) {
                console.log("[ajax-utils] controls already enabled");
                return;
            }
            console.log("[ajax-utils] enable controls"),
                $controls.each(function (i, el) {
                    var $txt = $(el).find(selectors.controlTxt);
                    (!$(el).is(selectors.alwaysTxtChange) && !$(el).is(selectors.activeControl)) || ($txt.length && $txt.text($txt.data("orig-text")));
                }),
                $controls.removeAttr("data-ajax-ctrl-active").removeAttr("disabled"),
                ($sliders = $controls.filter(".range-slider")),
                $sliders.siblings(".irs").removeAttr("disabled"),
                (window.rfd.ajaxControlsDisabled = !1);
        }
        function handleAjaxError() {
            console.error("AJAX error, re-enabling checkout buttons."), enable();
        }
        function init() {
            $(document).on("cart.requestComplete", handleRequestComplete), $(document).ajaxError(handleAjaxError);
        }
        init(), (window.rfd = window.rfd || {}), (window.rfd.disableBtns = disable), (window.rfd.enableBtns = enable);
    })(),
    (function () {
        "use strict";
        var selectors = {
            singleOptionSelector: "[data-single-option-selector]",
            productForms: "[data-ajax-product-form]",
            quickAddBtns: "[data-quick-add-to-cart]",
            quickAddVariantIdAttr: "data-quick-add-to-cart",
            preorderProperty: "data-preorder-line-property",
            quickAddHolder: "[data-quick-add-holder]",
            atcTextUpdate: "[data-add-to-cart-text]",
        };
        function ajaxAddToCart(data, callback, openModal = !0) {
            if (((Shopify.queue = []), data.variantId && data.quantity)) {
                Shopify.queue.push(data);
                const addon = data.addon;
                addon.variantId && addon.quantity && Shopify.queue.push(addon);
            } else if (data.length)
                data.forEach(function (d) {
                    d.variantId && d.quantity ? Shopify.queue.push(d) : console.error("[cart-add] invalid data", d);
                });
            else {
                console.error("[cart-add] invalid data", data);
                return;
            }
            (Shopify.moveAlong = function () {
                var request;
                window.rfd && window.rfd.cartupsellInit && window.rfd.cartupsellInit(),
                    Shopify.queue.length
                        ? ((request = Shopify.queue.shift()),
                          (request.customProperties = request.customProperties || {}),
                          console.log("[cart-add] adding", request),
                          CartJS.addItem(request.variantId, request.quantity, request.customProperties, {
                              success: function (data2) {
                                  Shopify.moveAlong();
                              },
                              error: function (jqXHR, textStatus, errorThrown) {
                                  console.timeEnd("[cart-add]"),
                                      console.error(jqXHR, textStatus, errorThrown),
                                      window.rfd && window.rfd.enableBtns && window.rfd.enableBtns(),
                                      window.rfd && window.rfd.cartupsellInit && window.rfd.cartupsellInit(),
                                      window.rfd &&
                                          window.rfd.alert &&
                                          jqXHR.responseJSON &&
                                          jqXHR.responseJSON.message &&
                                          jqXHR.responseJSON.description &&
                                          (window.rfd.alert(jqXHR.responseJSON.message, jqXHR.responseJSON.description), $.magnificPopup.instance.close(), window.rfd.renderCart(!openModal, window.rfd.enableBtns));
                              },
                          }))
                        : (console.timeEnd("[cart-add]"), callback ? callback() : window.rfd.renderCart(!openModal, window.rfd.enableBtns));
            }),
                console.time("[cart-add]"),
                Shopify.moveAlong();
        }
        function getFormData(form) {
            var id = $(form).find('[name="id"]').first().val(),
                addOnId = $(form).find('[name="addon_id"]').first().val(),
                quant = $(form).find('[name="quantity"]').first().val(),
                customProperties = {},
                $customPropFields = $(form).find('[name^="properties"]');
            return (
                (id = parseInt(id, 10)),
                id
                    ? (quant || ((quant = 1), console.info("[cart-add] no quant found in DOM, defaulting to 1")),
                      $customPropFields.each(function () {
                          var propVal = $(this).val(),
                              propName = $(this)
                                  .attr("name")
                                  .replace(/properties\[/gi, "")
                                  .replace(/\]/gi, "");
                          customProperties[propName] = propVal;
                      }),
                      { variantId: id, addon: { variantId: addOnId, quantity: 1 }, quantity: quant, customProperties })
                    : (console.error("[cart-add] no variant id", id), null)
            );
        }
        function handleProductFormSubmit(e) {
            var formData = getFormData(this);
            e.preventDefault(), window.rfd && window.rfd.disableBtns && window.rfd.disableBtns(this), formData && ajaxAddToCart(formData);
            var atcTextValue = $(selectors.atcTextUpdate).text();
            $(selectors.atcTextUpdate).text("Added to bag"),
                setTimeout(function () {
                    $(selectors.atcTextUpdate).text(atcTextValue);
                }, 1e3);
        }
        function handleQuickAddBtnClick(e) {
            var variantIds = $(this).attr(selectors.quickAddVariantIdAttr),
                variantIdsArr = variantIds.split(","),
                preorderProperty = $(this).attr(selectors.preorderProperty),
                variantsData = [],
                customProperties = {},
                quantEl = $(this).closest(selectors.quickAddHolder).find('[name="quantity"]'),
                quant = 1;
            if ((quantEl.length && (quant = quantEl.first().val()), e.preventDefault(), !variantIds)) {
                console.error("[cart-add] no variant IDs on add button");
                return;
            }
            (customProperties["Pre-Order Item"] = preorderProperty),
                variantIdsArr.forEach(function (id) {
                    variantsData.push({ quantity: quant, variantId: parseInt(id, 10), customProperties });
                }),
                window.rfd && window.rfd.disableBtns && window.rfd.disableBtns(this),
                console.log("ajax calllllll"),
                ajaxAddToCart(variantsData, null, window.innerWidth >= 768),
                document.querySelectorAll(".quick-close").forEach(function (element) {
                    element.parentElement.classList.add("display_none");
                });
        }
        function upsellItemVariants() {
            let variantID;
            $("body").on("click", "[data-upsell-item]", function () {
                let variant = [],
                    options = $(this).parents(".options"),
                    optionsID = "#" + options.data("options"),
                    optionsBtn = optionsID + "-btn",
                    variantElem = "";
                options.children("div").each(function () {
                    $(this).find("input:checked").length && variant.push($(this).find("input:checked").val());
                }),
                    variant.length &&
                        ((variantElem = $(optionsID).find(`[data-variant="${variant.join(" / ")}"]`)),
                        variantElem.length &&
                            (variantElem.attr("data-available") == "false"
                                ? (options.find(".unavailable").removeClass("hide"),
                                  setTimeout(function () {
                                      options.find(".unavailable").addClass("hide");
                                  }, 1500))
                                : ((variantID = variantElem.val()), $(optionsBtn).attr("data-quick-add-to-cart", variantID).trigger("click"))));
            }),
                $("body").on("click", ".toggle-options", function () {
                    $(this).toggleClass("active");
                });
        }
        function init() {
            upsellItemVariants(), $("body").on("submit", selectors.productForms, handleProductFormSubmit), $("body").on("click", selectors.quickAddBtns, handleQuickAddBtnClick);
        }
        init();
    })(),
    (function () {
        "use strict";
        var selectors = {
            cartForm: "[data-cart]",
            removeBtns: "[data-cart-remove]",
            lineNumberAttr: "data-cart-remove",
            cartItem: "[data-cart-item]",
            singlePrice: "data-item-single-price",
            itemTitle: "data-item-title",
            itemSKU: "data-item-sku",
            itemType: "data-item-type",
            itemProdId: "data-product-id",
        };
        function ajaxRemoveFromCart(lineNumber, removeBtn) {
            console.time("[cart-remove]"), console.log("[cart-remove] removing", lineNumber), removeBtn && window.rfd.disableBtns(removeBtn, window.theme.strings.removing);
            var $removeBtn = $('[data-cart-remove="' + lineNumber + '"]', selectors.cartForm),
                $quantBtn = $('[data-item-quantity="' + lineNumber + '"]', selectors.cartForm),
                $currentLineItem = $removeBtn.closest(selectors.cartItem),
                currentLineItemVariantID = $currentLineItem.attr("data-variant-id"),
                currentLineItemTitle = $currentLineItem.find("input").attr(selectors.itemTitle),
                currentLineItemSKU = $currentLineItem.find("input").attr(selectors.itemSKU),
                currentLineItemType = $currentLineItem.find("input").attr(selectors.itemType),
                currentLineItemPrice = $currentLineItem.find("input").attr(selectors.singlePrice) / 100,
                currentLineItemProductID = $currentLineItem.find("input").attr(selectors.itemProdId);
            if (
                (CartJS.removeItem(lineNumber, {
                    success: function () {
                        console.timeEnd("[cart-remove]"), window.rfd.renderCart(!1, window.rfd.enableBtns);
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        console.error(jqXHR, textStatus, errorThrown),
                            window.rfd && window.rfd.enableBtns && window.rfd.enableBtns(),
                            window.rfd && window.rfd.alert && jqXHR.responseJSON && jqXHR.responseJSON.message && jqXHR.responseJSON.description && window.rfd.alert(jqXHR.responseJSON.message, jqXHR.responseJSON.description);
                    },
                }),
                currentLineItemProductID == "7581630758986" && currentLineItemPrice == 0)
            ) {
                var vesselProduct = document.querySelector("[data-variant-id='41075391463498']"),
                    vesselLine = vesselProduct.getAttribute("data-variant-id");
                CartJS.removeItemById(vesselLine, {
                    success: function () {
                        console.timeEnd("[cart-remove]"), window.rfd.renderCart(!1, window.rfd.enableBtns);
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        console.error(jqXHR, textStatus, errorThrown),
                            window.rfd && window.rfd.enableBtns && window.rfd.enableBtns(),
                            window.rfd && window.rfd.alert && jqXHR.responseJSON && jqXHR.responseJSON.message && jqXHR.responseJSON.description && window.rfd.alert(jqXHR.responseJSON.message, jqXHR.responseJSON.description);
                    },
                });
            }
        }
        function handleRemoveClick(e) {
            var lineNumber = $(this).attr(selectors.lineNumberAttr);
            lineNumber ? (e.preventDefault(), ajaxRemoveFromCart(lineNumber, this)) : console.error("[cart-remove] invalid line number", lineNumber);
        }
        function init() {
            $("body").on("click", selectors.removeBtns, handleRemoveClick);
        }
        init();
    })(),
    (function () {
        "use strict";
        var selectors = { minicart: "#minicart", cartForm: "[data-cart]", alwaysStayClosed: "body.template-cart" },
            cartAjaxTemplate = "/cart?view=ajax",
            cartPageTemplate = "/cart?view=cart-page";
        function renderCart(dontOpen, callback) {
            var $cartEls = $(selectors.cartForm),
                chosenCartTemplate = cartAjaxTemplate;
            $(selectors.alwaysStayClosed).length && (chosenCartTemplate = cartPageTemplate),
                console.log("[cart-render] updating minicart"),
                $cartEls.length &&
                    (console.time("[cart-render]"),
                    $.get(chosenCartTemplate, function (data) {
                        var doNotOpen = dontOpen;
                        $(selectors.cartForm).replaceWith($(data)),
                            picturefill && picturefill(),
                            loadCartProductRecommendations(),
                            $(selectors.alwaysStayClosed).length && (doNotOpen = !0),
                            doNotOpen !== !0 &&
                                window.rfd &&
                                window.rfd.openMenu &&
                                ($.magnificPopup && $.magnificPopup.close(),
                                window.rfd.openMenu(selectors.minicart),
                                $(".cart__body").addClass("cart__body--updating"),
                                setTimeout(function () {
                                    $(".cart__body").removeClass("cart__body--updating");
                                }, 200)),
                            console.timeEnd("[cart-render]"),
                            callback && callback();
                    }));
        }
        window.rfd.renderCart = renderCart;
    })(),
    (function () {
        "use strict";
        var selectors = {
            quant: "[data-item-quantity]",
            removeBtn: "[data-cart-remove]",
            cartItem: "[data-cart-item]",
            lineNumberAttr: "data-item-quantity",
            currentQuantAttr: "data-current-val",
            singlePrice: "data-item-single-price",
            itemTitle: "data-item-title",
            itemSKU: "data-item-sku",
            itemType: "data-item-type",
            itemProdId: "data-product-id",
        };
        function updateQuant(lineNumber, newQuant, control, direction) {
            console.time("[cart-update]"), console.log("[cart-update] updating #" + lineNumber + " x " + newQuant), control && window.rfd && window.rfd.disableBtns && window.rfd.disableBtns(control, window.theme.strings.updating);
            var lineNumbers = [lineNumber],
                $currentLineItem = control.closest(selectors.cartItem),
                currentLineItemVariantID = $currentLineItem.attr("data-variant-id"),
                currentLineItemProductID = $currentLineItem.find("input").attr(selectors.itemProdId),
                currentLineItemTitle = $currentLineItem.find("input").attr(selectors.itemTitle),
                currentLineItemSKU = $currentLineItem.find("input").attr(selectors.itemSKU),
                currentLineItemType = $currentLineItem.find("input").attr(selectors.itemType),
                currentLineItemPrice = $currentLineItem.find("input").attr(selectors.singlePrice) / 100;
            if (currentLineItemProductID == "7581630758986" && currentLineItemPrice == 0 && direction == "down") {
                var vesselProduct = document.querySelector("[data-variant-id='41075391463498']"),
                    vesselLine = vesselProduct.getAttribute("data-line-number");
                lineNumbers.push(vesselLine);
            }
            for (let i = 0; i < lineNumbers.length; i++)
                CartJS.updateItem(
                    lineNumbers[i],
                    newQuant,
                    {},
                    {
                        success: function () {
                            console.timeEnd("[cart-update]"), window.rfd && window.rfd.renderCart && window.rfd.renderCart(!1, window.rfd.enableBtns);
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            console.timeEnd("[cart-update]"),
                                console.error(jqXHR, textStatus, errorThrown),
                                window.rfd && window.rfd.enableBtns && window.rfd.enableBtns(),
                                window.rfd && window.rfd.alert && jqXHR.responseJSON && jqXHR.responseJSON.message && jqXHR.responseJSON.description && window.rfd.alert(jqXHR.responseJSON.message, jqXHR.responseJSON.description);
                        },
                    }
                );
        }
        function handleQuantChange(e) {
            var $control = $(this),
                oldQuant = parseInt($control.attr(selectors.currentQuantAttr), 10),
                newQuant = parseInt($control.val(), 10),
                maxQuant = $control.attr("max"),
                minQuant = $control.attr("min"),
                lineNumber = $control.attr(selectors.lineNumberAttr),
                $removeBtn = $(this).closest(selectors.cartItem).find(selectors.removeBtn);
            if (
                (e.preventDefault(),
                maxQuant && newQuant > maxQuant && (console.log("[cart-update] hit max"), (newQuant = maxQuant)),
                minQuant && newQuant < minQuant && (console.log("[cart-update] hit min"), (newQuant = minQuant)),
                newQuant === oldQuant)
            ) {
                console.log("[cart-update] no quant change");
                return;
            }
            if (newQuant > oldQuant) var direction = "up";
            if (newQuant < oldQuant) var direction = "down";
            updateQuant(lineNumber, newQuant, $removeBtn, direction);
        }
        function init() {
            $("body").on("change", selectors.quant, handleQuantChange);
        }
        init();
    })(),
    (function () {
        var selectors = { tagGroup: "[data-sort-group]", customSortAttr: "data-sort-group", tagSort: "[data-sort]", tagSortValAttr: "data-sort" };
        function sortTags() {
            var $tagGroups = $(selectors.tagGroup);
            $tagGroups.each(function (index, g) {
                var $tagsToSort = $(g).find(selectors.tagSort),
                    sortIndexes = [],
                    sortIndexesLetters = ["XXXS", "XXS", "XS", "S", "S+", "S++", "S+++", "M", "L", "XL", "XXL", "XXXL"],
                    customSortVals = $(this).attr(selectors.customSortAttr),
                    isCustomSort = customSortVals.length,
                    isNumeric = !1,
                    isNonNumeric = !1,
                    i,
                    j,
                    $nextTag;
                if (
                    (isCustomSort &&
                        ((customSortVals = customSortVals.split(",")),
                        (customSortVals = customSortVals.map(function (x2) {
                            return x2.trim().toLowerCase();
                        }))),
                    !!$tagsToSort.length)
                ) {
                    if (
                        ($tagsToSort.each(function (index2, t) {
                            sortIndexes.push(parseFloat($(t).attr(selectors.tagSortValAttr), 10));
                        }),
                        sortIndexes.forEach(function (val) {
                            $.isNumeric(val) ? (isNumeric = !0) : (isNonNumeric = !0);
                        }),
                        isNumeric)
                    )
                        for (
                            sortIndexes.sort(function (a, b) {
                                return b - a;
                            }),
                                i = 0;
                            i < sortIndexes.length;
                            i += 1
                        )
                            ($nextTag = $tagsToSort.filter('[data-sort="' + sortIndexes[i] + '"]')), $(g).prepend($nextTag);
                    if (isNonNumeric)
                        for (sortIndexes = isCustomSort ? customSortVals : sortIndexesLetters, j = sortIndexes.length - 1; j >= 0; j -= 1)
                            ($nextTag = $tagsToSort.filter('[data-sort="' + sortIndexes[j].toLowerCase() + '"], [data-sort="' + sortIndexes[j].toUpperCase() + '"]')), $(g).prepend($nextTag);
                }
            });
        }
        function _init() {
            sortTags();
        }
        _init(), (window.rfd = window.rfd || {}), (window.rfd.sortTags = sortTags);
    })(),
    (theme.helpers = (function () {
        var isDesktop = function () {
                return $(window).width() >= 750;
            },
            isMobile = function () {
                return $(window).width() < 750;
            },
            calcCSS = function (value1, value2) {
                return "calc(" + value1 + "px + " + value2;
            },
            foundSelectors = function (selectorsObj) {
                var foundSelectors3 = !1,
                    selectors = new String(),
                    $selectors;
                return (
                    $.each(selectorsObj, function (index, selector) {
                        selectors += selector.trim() + ",";
                    }),
                    (selectors = selectors.trim().substring(0, selectors.length - 1)),
                    ($selectors = $(selectors).length),
                    $selectors && (foundSelectors3 = !0),
                    foundSelectors3
                );
            },
            foundAllSelectors = function (selectorsObj) {
                var foundSelectors2 = !1,
                    selectors = new String(),
                    $selectors;
                return (
                    $.each(selectorsObj, function (index, selector) {
                        selectors += selector.trim() + ",";
                    }),
                    (selectors = selectors.trim().substring(0, selectors.length - 1)),
                    ($selectors = $(selectors).length),
                    $selectors == objSize(selectorsObj) && (foundSelectors2 = !0),
                    foundSelectors2
                );
            },
            objSize = function (object) {
                var size = 0;
                for (key in object) object.hasOwnProperty(key) && size++;
                return size;
            },
            parseQueryParams = function (windowLocationSearch) {
                var search = windowLocationSearch.substring(1);
                if (search) return JSON.parse('{"' + decodeURIComponent(search.replace(/&/g, '","').replace(/=/g, '":"')) + '"}');
            },
            getQueryParamByName = function (name, url) {
                url || (url = window.location.href), (name = name.replace(/[\[\]]/g, "\\$&"));
                var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                    results = regex.exec(url);
                return results ? (results[2] ? decodeURIComponent(results[2].replace(/\+/g, " ")) : "") : null;
            },
            parseSelectorDataToValue = function (selector) {
                var dataset = selector.replace("[data-", "").replace("]", "").trim();
                return $(selector).data(dataset);
            },
            dataAttrNoPrefix = function (selector) {
                return selector.replace("[data-", "").replace("]", "").trim();
            };
        return { isDesktop, isMobile, calcCSS, parseQueryParams, getQueryParamByName, parseSelectorDataToValue, foundSelectors, foundAllSelectors, dataAttrNoPrefix };
    })()),
    $(function () {
        $("html").one("touchstart", function () {
            $("body").addClass("touchevents").removeClass("no-touchevents");
        });
    }),
    (function () {
        var selectors = { form: "form[data-validate], [data-validate] form" };
        function _init() {
            var validate = new Bouncer(selectors.form, {
                fieldClass: "error",
                errorClass: "error-message",
                fieldPrefix: "bouncer-field_",
                errorPrefix: "bouncer-error_",
                patterns: {
                    email: /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*(\.\w{2,})+$/,
                    url: /^(?:(?:https?|HTTPS?|ftp|FTP):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/,
                    number: /[-+]?[0-9]*[.,]?[0-9]+/,
                    color: /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/,
                    date: /(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))/,
                    time: /(0[0-9]|1[0-9]|2[0-3])(:[0-5][0-9])/,
                    month: /(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2]))/,
                },
                messageAfterField: !0,
                messageCustom: "data-bouncer-message",
                messageTarget: "data-bouncer-target",
                messages: {
                    missingValue: {
                        checkbox: window.theme.strings.validate.messageMissingValueCheckbox,
                        radio: window.theme.strings.validate.messageMissingValueRadio,
                        select: window.theme.strings.validate.messageMissingValueSelect,
                        "select-multiple": window.theme.strings.validate.messageMissingValueSelectMultiple,
                        default: window.theme.strings.validate.messageMissingValueDefault,
                    },
                    patternMismatch: {
                        email: window.theme.strings.validate.messagePatternMismatchEmail,
                        url: window.theme.strings.validate.messagePatternMismatchUrl,
                        number: window.theme.strings.validate.messagePatternMismatchNumber,
                        color: window.theme.strings.validate.messagePatternMismatchColor,
                        date: window.theme.strings.validate.messagePatternMismatchDate,
                        time: window.theme.strings.validate.messagePatternMismatchTime,
                        month: window.theme.strings.validate.messagePatternMismatchMonth,
                        default: window.theme.strings.validate.messagePatternMismatchDefault,
                    },
                    outOfRange: { over: window.theme.strings.validate.messageOutOfRangeOver, under: window.theme.strings.validate.messageOutOfRangeUnder },
                    wrongLength: { over: window.theme.strings.validate.messageWrongLengthOver, under: window.theme.strings.validate.messageWrongLengthUnder },
                },
                disableSubmit: !1,
                emitEvents: !0,
            });
        }
        _init();
    })(),
    (function () {
        var selectors = { input: "[data-quant-input]", select: "[data-quant-select]", minus: "[data-quant-minus]", plus: "[data-quant-plus]", quickAddInput: "[data-quick-add-holder] [data-quant-input]" };
        function adjustVal(adjustCtrl, amount) {
            var fieldSelector = $(adjustCtrl).attr("data-for"),
                $field = $(adjustCtrl).closest("form").find(selectors.input).filter(fieldSelector).first(),
                minVal = parseInt($field.attr("min"), 10),
                maxVal = parseInt($field.attr("max"), 10),
                currentVal = parseInt($field.val(), 10),
                newVal = currentVal + amount;
            if ((minVal > maxVal && (maxVal = minVal), $field.prop("disabled") === !0)) {
                console.log("Quant disabled");
                return;
            }
            if (!Number.isNaN(minVal) && newVal < minVal) {
                console.log("Quant prevented from going below min");
                return;
            }
            if (!Number.isNaN(maxVal) && newVal > maxVal) {
                console.log("Quant prevented from exceeding max");
                return;
            }
            if (currentVal === newVal) {
                console.log("No quant change");
                return;
            }
            Number.isNaN(newVal) || $(adjustCtrl).closest("form").find(fieldSelector).val(newVal).trigger("change");
        }
        function handleValChange(event, isSelect) {
            var maxVal = parseInt($(this).attr("max"), 10),
                minVal = parseInt($(this).attr("min"), 10),
                newVal = parseInt($(this).val(), 10);
            !isSelect && maxVal && !Number.isNaN(maxVal) && newVal > maxVal && (console.log("Quant set to max"), (newVal = maxVal)),
                !isSelect && minVal && !Number.isNaN(minVal) && newVal < minVal && (console.log("Quant set to min"), (newVal = minVal)),
                $(this).closest("form").find(selectors.input).val(newVal);
        }
        function handleMinusClick(e) {
            e.preventDefault(), adjustVal(this, -1);
        }
        function handlePlusClick(e) {
            e.preventDefault(), adjustVal(this, 1);
        }
        function handleQuickAddClick(e) {
            e.preventDefault();
        }
        function init() {
            $(selectors.quickAddInput).on("click", handleQuickAddClick),
                $(selectors.input).on("change", handleValChange),
                $(selectors.select).on("change", function (e) {
                    handleValChange.call(this, e, !0);
                }),
                $("body").on("click", selectors.minus, handleMinusClick),
                $("body").on("click", selectors.plus, handlePlusClick);
        }
        init();
    })(),
    (function menuAccordionFunction() {
        function initAccordion(el) {
            for (
                var accordion = el,
                    items = accordion.querySelectorAll(".js-accordion-item"),
                    itemsL = items.length,
                    triggers = accordion.querySelectorAll(".js-accordion-trigger"),
                    hiddenContent = accordion.querySelectorAll(".js-accordion-hidden"),
                    filtersAccordion = accordion.classList.contains("filters__accordion"),
                    pastItem = document.body.getAttribute("data-filter-open"),
                    openEvents = [],
                    current = null,
                    clearDisplayTimeout = null,
                    x2 = 0;
                x2 < itemsL;
                x2++
            )
                openEvents.push(openEvent.bind(this, x2));
            for (var x2 = 0; x2 < itemsL; x2++) typeof triggers[x2] < "u" && triggers[x2] != null && triggers[x2].addEventListener("click", openEvents[x2]);
            pastItem && openEvent(parseInt(pastItem), null),
                filtersAccordion && pastItem && (openEvent(parseInt(pastItem), null, !0), checkActiveFilters()),
                setTimeout(function () {
                    accordion.classList.add("init");
                }, 250);
            function openEvent(x3, e) {
                var preset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                if ((e && e.preventDefault(), clearDisplayTimeout && clearTimeout(clearDisplayTimeout), current !== null && !preset)) {
                    var index = current;
                    if (
                        (items[current].classList.remove("open"),
                        hiddenContent[current].style.removeProperty("max-height"),
                        filtersAccordion && document.body.setAttribute("data-filter-open", ""),
                        (clearDisplayTimeout = setTimeout(function () {
                            hiddenContent[index].style.removeProperty("display");
                        }, 800)),
                        x3 === current)
                    ) {
                        current = null;
                        return;
                    }
                }
                if (
                    (typeof hiddenContent[x3] < "u" && hiddenContent[x3] != null && (hiddenContent[x3].style.display = "block"),
                    typeof items[x3] < "u" && items[x3] != null && items[x3].classList.add("open"),
                    typeof hiddenContent[x3] < "u" && hiddenContent[x3] != null)
                ) {
                    var firstChild = hiddenContent[x3].querySelector("*");
                    firstChild && (hiddenContent[x3].style.maxHeight = firstChild.offsetHeight + "px");
                }
                (current = x3), filtersAccordion && document.body.setAttribute("data-filter-open", current);
            }
            function capitaliseTagWords(s) {
                if (typeof s != "string") return "";
                if (s.length < 3) return s.toUpperCase();
                for (var words = s.split(" "), capitalisedString = "", _x = 0; _x < words.length; _x++)
                    words[_x].length < 3 ? (capitalisedString += words[_x]) : (capitalisedString += words[_x].charAt(0).toUpperCase() + words[_x].slice(1)), words.length > 1 && _x < words.length - 1 && (capitalisedString += " ");
                return capitalisedString;
            }
            function checkActiveFilters() {
                for (var _x2 = 0; _x2 < itemsL; _x2++) {
                    var activeItems = items[_x2].querySelectorAll(".checkboxes__checkbox.is-active");
                    if (activeItems.length) {
                        triggers[_x2].querySelector("span").innerHTML += " /";
                        var activeList = document.createElement("span");
                        activeList.innerHTML = " ";
                        for (var y2 = 0; y2 < activeItems.length; y2++) {
                            var tagName = activeItems[y2].getAttribute("data-tag-name");
                            (activeList.innerHTML += capitaliseTagWords(tagName)),
                                activeItems.length > 1 && (y2 === activeItems.length - 2 ? (activeList.innerHTML += " and ") : y2 < activeItems.length - 1 && (activeList.innerHTML += ", "));
                        }
                        triggers[_x2].appendChild(activeList);
                    }
                }
            }
        }
        function _init() {
            for (var accordions = document.querySelectorAll('.js-block[data-block="accordion"]'), x2 = 0; x2 < accordions.length; x2++) initAccordion(accordions[x2]);
        }
        _init(), (window.rfd = window.rfd || {}), (window.rfd.menuAccordionFunction = menuAccordionFunction);
    })(),
    (function () {
        function loop() {
            for (var mainNavs = document.querySelectorAll('.js-block[data-block="main-nav"]'), x2 = 0; x2 < mainNavs.length; x2++) init(mainNavs[x2]);
        }
        function init(el) {
            var menu = el,
                header = document.querySelector(".site-header"),
                shopTrigger = document.querySelector(".js-shop-menu-trigger"),
                collectionsTrigger = document.querySelector(".js-collections-menu-trigger"),
                searchTrigger = document.querySelector(".js-main-menu-search-trigger"),
                skipLinks = menu.querySelectorAll(".js-access-skip"),
                searchInput = document.querySelector(".main-nav__search-form input"),
                shopLink = document.querySelector(".js-collections-shop-link"),
                open = !1,
                countdown = null;
            menu.addEventListener("mousemove", clearCountdownToClose),
                menu.addEventListener("focusin", clearCountdownToClose),
                menu.addEventListener("focusin", openMenu),
                menu.addEventListener("mouseleave", closeMenu),
                menu.addEventListener("focusout", countdownToClose),
                shopTrigger && shopTrigger.addEventListener("mouseenter", setShopMenu),
                shopTrigger && shopTrigger.addEventListener("focusin", setShopMenuFocus),
                collectionsTrigger && collectionsTrigger.addEventListener("mouseenter", setCollectionsMenu),
                collectionsTrigger && collectionsTrigger.addEventListener("focusin", setCollectionsMenuFocus),
                collectionsTrigger && collectionsTrigger.addEventListener("click", preventCollClick),
                shopTrigger && shopTrigger.addEventListener("mouseleave", countdownToClose),
                shopTrigger && shopTrigger.addEventListener("focusout", countdownToClose),
                collectionsTrigger && collectionsTrigger.addEventListener("mouseleave", countdownToClose),
                collectionsTrigger && collectionsTrigger.addEventListener("focusout", countdownToClose),
                searchTrigger && searchTrigger.addEventListener("click", setSearchMenu),
                shopLink && shopLink.addEventListener("mouseenter", closeMenu),
                shopLink && shopLink.addEventListener("focusin", closeMenu);
            function countdownToClose() {
                countdown = setTimeout(closeMenu, 1500);
            }
            function clearCountdownToClose() {
                countdown && clearTimeout(countdown);
            }
            function setShopMenuFocus() {
                setShopMenu(), focusAccessKey(0);
            }
            function setShopMenu() {
                clearCountdownToClose(), setMenu("shop"), open || openMenu();
            }
            function setCollectionsMenuFocus() {
                setCollectionsMenu(), focusAccessKey(1);
            }
            function preventCollClick(e) {
                e.preventDefault();
            }
            function setCollectionsMenu() {
                clearCountdownToClose(), setMenu("collections"), open || openMenu();
            }
            function setSearchMenu() {
                clearCountdownToClose(), setMenu("search"), open || openMenu(), searchInput.focus();
            }
            function setMenu(menuName) {
                header.setAttribute("data-menu", menuName), menu.setAttribute("data-menu", menuName);
            }
            function clearMenu() {
                header.setAttribute("data-menu", ""), menu.setAttribute("data-menu", "");
            }
            function focusAccessKey(x2) {
                console.log(skipLinks[x2]);
                const accessBtn = skipLinks[x2];
                accessBtn && accessBtn.focus();
            }
            function openMenu() {
                (open = !0), header.classList.add("open"), menu.classList.add("open");
            }
            function closeMenu() {
                (open = !1), header.classList.remove("open"), menu.classList.remove("open"), (countdown = null), clearMenu();
            }
        }
        loop();
    })(),
    (function () {
        function loop() {
            for (var mobileNavs = document.querySelectorAll('.js-block[data-block="mobile-nav"]'), x2 = 0; x2 < mobileNavs.length; x2++) init(mobileNavs[x2]);
        }
        function init(el) {
            var menu = el,
                openTrigger = document.querySelector(".js-mobile-menu-open-trigger"),
                closeTrigger = menu.querySelector(".js-mobile-menu-close-trigger"),
                searchTrigger = document.querySelector(".js-mobile-menu-search-trigger"),
                searchInput = menu.querySelector(".mobile-nav__search-form #mobile-search"),
                backTrigger = menu.querySelector(".js-mobile-menu-back-trigger"),
                shopTrigger = menu.querySelector(".js-mobile-menu-shop-trigger"),
                collectionsTrigger = menu.querySelector(".js-mobile-menu-collection-trigger"),
                open = !1;
            openTrigger.addEventListener("click", openMenu),
                closeTrigger.addEventListener("click", closeMenu),
                searchTrigger.addEventListener("click", showSearch),
                backTrigger.addEventListener("click", showPrimary),
                shopTrigger.addEventListener("click", showShop),
                collectionsTrigger.addEventListener("click", showCollections),
                window.addEventListener("resize", closeOnResize),
                (menu.style.display = "block");
            function showSearch() {
                menu.setAttribute("data-menu", "search"),
                    setTimeout(function () {
                        searchInput.focus();
                    }, 500),
                    openMenu();
            }
            function showPrimary() {
                menu.setAttribute("data-menu", "primary");
            }
            function showShop() {
                menu.setAttribute("data-secondary", 1), showSecondary();
            }
            function showCollections() {
                menu.setAttribute("data-secondary", 2), showSecondary();
            }
            function showSecondary() {
                menu.setAttribute("data-menu", "secondary");
            }
            function openMenu() {
                open || ((open = !0), menu.classList.add("open"), document.querySelector("body").setAttribute("data-modal-open", !0));
            }
            function closeMenu() {
                open && ((open = !1), menu.classList.remove("open"), setTimeout(showPrimary, 400), document.querySelector("body").setAttribute("data-modal-open", !1));
            }
            function closeOnResize() {
                window.innerWidth > 1024 && closeMenu();
            }
        }
        loop();
    })(),
    (window.theme.mediaQuery = (function () {
        var breakpoints = { xsmall: 375, small: 550, medium: 768, large: 990, widescreen: 1400 },
            mediaStrings = {
                xxsmall: "(max-width: " + (breakpoints.xsmall - 1) + "px)",
                small: "(max-width:  " + (breakpoints.medium - 1) + "px)",
                "medium-up": "(min-width: " + breakpoints.medium + "px)",
                "large-up": "(min-width: " + breakpoints.large + "px)",
                widescreen: "(min-width: " + breakpoints.widescreen + "px)",
            };
        function test(label) {
            var string = mediaStrings[label];
            return string ? window.matchMedia(string).matches : !1;
        }
        return test;
    })()),
    (function () {
        var selectors = { module: ".lazy-pag", grid: ".lazy-pag__grid", pag: ".lazy-pag__next", item: ".lazy-pag__item", gridCount: "[data-grid-count]" },
            $grid;
        function updateGridCount() {
            var count = $(selectors.filterResults).find(".product-grid__item").length,
                noResultsMsge = '<div class="empty-selection">Your filter selection did not yield results.</div>';
            count == 0 && $(selectors.filterResults).append(noResultsMsge);
        }
        function handleAppend(event, response, path, items) {
            console.log("[lazy-pag] appended " + items.length),
                updateGridCount(),
                window.rfd && window.rfd.orderGrid && window.rfd.orderGrid($grid[0], items),
                window.rfd && window.rfd.reinitQuickAdd && window.rfd.reinitQuickAdd(),
                window.rfd && window.rfd.reinitListingVideo && window.rfd.reinitListingVideo(),
                typeof ReloadSmartWishlist < "u" && $.isFunction(ReloadSmartWishlist) && ReloadSmartWishlist(),
                typeof collectionPageMobileCarousel < "u" && $.isFunction(collectionPageMobileCarousel) && collectionPageMobileCarousel();
        }
        function handleRequest(event, path) {
            console.log("[lazy-pag] loading page: " + path);
        }
        function handleLast() {
            console.log("[lazy-pag] last page loaded");
        }
        function init() {
            ($grid = $(selectors.grid).infiniteScroll({ append: selectors.item, scrollThreshold: 600, path: selectors.pag, checkLastPage: !0, history: !1 })),
                $grid.on("append.infiniteScroll", handleAppend),
                $grid.on("request.infiniteScroll", handleRequest),
                $grid.on("last.infiniteScroll", handleLast);
        }
        if (!$(selectors.pag).length) {
            console.log("[lazy-pag] disabled (no next page link)");
            return;
        }
        function reinit() {
            $grid && $grid.data("infiniteScroll") && $grid.infiniteScroll("destroy"), init(), console.log("[lazy-pag] reinit");
        }
        function loadNextPage() {
            $grid.infiniteScroll("loadNextPage");
        }
        init(), (window.rfd = window.rfd || {}), (window.rfd.lazyPagReinit = reinit), (window.rfd.loadNextPage = loadNextPage);
    })(),
    (function () {
        function initcookieBanner(el) {
            var cookie = document.querySelector(".cookie-policy"),
                cookie_bar = document.querySelector(".cookie-policy__bar"),
                closeButton = cookie.querySelector(".btn--accept");
            xButton = cookie.querySelector(".btn--close");
            var open = !0;
            document.querySelector("body").setAttribute("data-modal-open", !0),
                (cookie.style.display = "block"),
                closeButton.addEventListener("click", closeCookieBar),
                xButton.addEventListener("click", closeCookieBar),
                window.localStorage.getItem("accept_cookies") &&
                    ((open = !1), cookie.setAttribute("data-open", !1), document.querySelector("body").setAttribute("data-modal-open", !1), (cookie.style.display = "none"), (cookie_bar.style.display = "none"));
            function closeCookieBar() {
                (open = !1), window.localStorage.setItem("accept_cookies", !0), cookie.setAttribute("data-open", !1), document.querySelector("body").setAttribute("data-modal-open", !1), (cookie.style.display = "none");
            }
        }
        initcookieBanner();
    })(),
    (function () {
        function getCookie(cname) {
            var name = cname + "=",
                ca = document.cookie.split(";"),
                i,
                c;
            for (i = 0; i < ca.length; i += 1) {
                for (c = ca[i]; c.charAt(0) === " "; ) c = c.substring(1);
                if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
            }
            return "";
        }
        getCookie("cookieControl") || $("body").addClass("has-cookie-banner"), window.location.href.indexOf("iwish") > -1 && $("body").addClass("template-saved-for-later");
    })(),
    (function () {
        var selectors = {
                singleOptionSelector: "[data-single-option-selector]",
                originalSelectorId: "[data-product-select]",
                input: ".product-quantity__num",
                inventoryDisplay: "[inventory-display]",
                showInventory: "data-threshold",
                inventoryDisplayNumber: "[inventory-display-number]",
                inventoryMessage: ".variant-inventory__message",
                inventoryLastOne: ".variant-inventory__last-one",
                progressBar: ".progress-bar__progress",
            },
            $inventoryDisplay = $(selectors.inventoryDisplay),
            showInventory = $inventoryDisplay.attr(selectors.showInventory);
        function inventoryDisplayUpdate(currentInventory) {
            var progress;
            showInventory > currentInventory
                ? (currentInventory === 1
                      ? ($(selectors.inventoryMessage).addClass("hide"), $(selectors.inventoryLastOne).removeClass("hide"))
                      : ($(selectors.inventoryMessage).removeClass("hide"), $(selectors.inventoryLastOne).addClass("hide")),
                  $(selectors.inventoryDisplayNumber).text(currentInventory),
                  (progress = Math.floor((currentInventory / showInventory) * 100)),
                  $(selectors.progressBar).css("width", progress + "%"),
                  $inventoryDisplay.slideDown())
                : $inventoryDisplay.slideUp();
        }
        function handleValChange() {
            var $closestForm = $(this).closest("form");
            setTimeout(function () {
                var $selectedVariant = $closestForm.find(selectors.originalSelectorId + " option:selected"),
                    $variantInventory = $selectedVariant.data("max");
                $selectedVariant.data("max")
                    ? ($selectedVariant.closest("form").find($(selectors.input)).attr("max", $variantInventory),
                      $selectedVariant.closest("form").find($(selectors.input)).val() > $variantInventory && (console.log("Too many"), $selectedVariant.closest("form").find($(selectors.input)).val($variantInventory)),
                      inventoryDisplayUpdate($variantInventory))
                    : ($selectedVariant.closest("form").find($(selectors.input)).removeAttr("max"), $inventoryDisplay.slideUp());
            }, 50);
        }
        function _init() {
            $(selectors.singleOptionSelector).on("change", handleValChange);
        }
        _init();
    })(),
    (function () {
        function init() {
            document.addEventListener && document.addEventListener("touchstart", function () {}, !1),
                document.addEventListener(
                    "touchstart",
                    function addtouchclass(e) {
                        document.documentElement.classList.add("is-touch"), document.removeEventListener("touchstart", addtouchclass, !1);
                    },
                    !1
                );
        }
        init();
    })(),
    (function () {
        function _init() {
            var selectors = { cartCount: "[data-cart-item-count]" };
            performance.navigation.type == 2 && (window.rfd.renderCart(!0, window.rfd.enableBtns), $(selectors.cartCount).html(window.theme.cartJSON.item_count), console.log("[Browser back] render cart"));
        }
        _init();
    })(),
    $(function () {
        "use strict";
        var selectors = {
            module: "[data-filters]",
            filterDrawer: ".collection-filters",
            group: "[data-filters-group]",
            filterResults: "[data-filters-results]",
            filterPag: "[data-filters-pag]",
            filterGroup: ".filter-group",
            filterGroupList: ".filter-group__list",
            filterGroupItem: ".filter-group__item",
            filterLinks: "[data-filter-link]",
            filterLinksValAttr: "data-tag-value",
            filterSort: "[data-filters] [data-filter-sort], [data-filters-group] [data-filter-sort]",
            filterSummary: "[data-filter-summary]",
            filterSummaryActive: "[data-filter-summary-active]",
            sortUi: "[data-sort-ui]",
            sortBtn: "[data-sort-btn-text]",
            collectionLinks: "[data-collection-link]",
            resetBtn: "[data-filters-reset]",
            applyBtn: "[data-filters-apply]",
            summaryLink: "[data-filter-link]:not([data-collection-link])",
            active: ".is-active",
            selectToggle: "[data-select-toggle]",
            slider: "[data-filter-slider]",
            sliderIdAttr: "data-filter-slider",
            checkbox: "[data-filter-checkbox]",
            checkboxes: "[data-filter-checkboxes]",
            checkboxesIdAttr: "data-filter-checkboxes",
            gridCount: "[data-grid-count]",
            accordionItem: ".js-accordion-item",
            emptyResults: ".empty-selection",
        };
        function filtersFunction() {
            function loop() {
                for (var filters = document.querySelectorAll('.js-block[data-block="filters"]'), x2 = 0; x2 < filters.length; x2++) init2(filters[x2]);
            }
            function init2(el) {
                var filters = el,
                    siteHeader = document.querySelector(".site-header"),
                    toggleTrigger = filters.querySelector(".js-filters-toggle-trigger"),
                    closeTrigger = filters.querySelector(".js-filters-close-trigger"),
                    nextFocusItem = document.querySelector(".layout-sort__column-count-trigger--gallery"),
                    applyBtn = filters.querySelector(".js-apply-filters-btn"),
                    clearBtn = filters.querySelector(".js-clear-filters-btn"),
                    currentState = document.body.classList.contains("filters-open"),
                    open = currentState;
                filters.addEventListener("focusin", checkFiltersOpen),
                    nextFocusItem.addEventListener("focusin", checkFiltersClosed),
                    toggleTrigger.addEventListener("click", toggleFilters),
                    closeTrigger.addEventListener("click", closeFilters),
                    applyBtn && applyBtn.addEventListener("click", closeFilters),
                    window.innerWidth <= 1024 && clearBtn.addEventListener("click", closeFilters);
                function checkFiltersOpen() {
                    !open && window.innerWidth > 1024 && setTimeout(openFilters, 100);
                }
                function checkFiltersClosed() {
                    open && window.innerWidth > 1024 && closeFilters();
                }
                function toggleFilters() {
                    open ? closeFilters() : openFilters();
                }
                function openFilters() {
                    (open = !0), siteHeader.classList.add("mobile-hidden"), document.body.classList.add("filters-open");
                }
                function closeFilters() {
                    (open = !1), siteHeader.classList.remove("mobile-hidden"), document.body.classList.remove("filters-open");
                }
            }
            loop();
        }
        filtersFunction();
        var sliderVals = {},
            checkboxesVals = {},
            filteredUrl = null,
            defaultSelectText = $(selectors.selectToggle).text(),
            sort = { query: null, cleared: !1 };
        function updateGridCount() {
            var $gridCount = $(selectors.gridCount),
                count = $(selectors.filterResults).find(".product-grid__item").length,
                noResultsMsge = '<div class="empty-selection">Your filter selection did not yield results.</div>';
            count == 0 ? (console.log("[filters] Grid count is EMPTY"), $(selectors.filterResults).append(noResultsMsge)) : $gridCount.append("(" + count + " Items)");
        }
        function hideEmptyFilters() {
            $(selectors.filterGroup).each(function () {
                var $slider = $(this).find(selectors.slider),
                    $list = $(this).find(selectors.filterGroupList),
                    $items = $(this).find(selectors.filterGroupItem);
                (($list.length && !$items.length) || (!$slider.length && !$list.length)) && $(this).hide();
            });
        }
        function getFiltersAjaxUrl(url) {
            var ajaxUrl = url;
            return ajaxUrl || (ajaxUrl = window.location.pathname), ajaxUrl.indexOf("view=filters-only") === -1 ? (ajaxUrl.indexOf("?") === -1 ? ajaxUrl + "?view=filters-only" : ajaxUrl.replace("?", "?view=filters-only&")) : ajaxUrl;
        }
        function setSortActiveState() {
            var $filterSorts = $(selectors.filterSort);
            if (sort.query) {
                console.log("[filters] restore active sort"),
                    $filterSorts
                        .filter('[href="' + sort.query + '"]')
                        .addClass("is-active")
                        .closest(selectors.filterGroupItem)
                        .addClass("is-active");
                return;
            }
            if (sort.cleared) {
                console.log("[filters] restore cleared sort"), $filterSorts.removeClass("is-active");
                return;
            }
            var sortVal = window.location.search.match(/\?(sort_by=.*?)(&|$|#)/i);
            if (sortVal && sortVal.length) (sortVal = sortVal[1]), console.log("[filters] sort value", sortVal);
            else return;
            var $activeSort = $filterSorts.filter('[href*="' + sortVal + '"]');
            $activeSort.length &&
                ($filterSorts.removeClass("is-active").closest(selectors.filterGroupItem).removeClass("is-active"),
                $activeSort.addClass("is-active").closest(selectors.filterGroupItem).addClass("is-active"),
                console.log("[filters] set active sort"),
                $(selectors.selectToggle).text($activeSort.text()));
        }
        function fixCollectionsActiveState() {
            var $collectionLinks = $(selectors.collectionLinks);
            $collectionLinks.filter(".is-active").length === 0 &&
                $collectionLinks.each(function () {
                    var urlMatch = window.location.href.indexOf($(this).attr("href"));
                    urlMatch !== -1 && $(this).addClass("is-active").closest(selectors.filterGroupItem).addClass("is-active");
                });
        }
        function setSliderVal(slider, sliderVal) {
            var sliderData = $(slider).data("ionRangeSlider"),
                vals = sliderVal.split(";"),
                fromIndex,
                toIndex;
            if (!$.isFunction(sliderData.update)) {
                console.error("[filters] no update method", this);
                return;
            }
            if ($(slider).val() !== sliderVal) {
                if (((fromIndex = sliderData.options.p_values.indexOf(vals[0])), (toIndex = sliderData.options.p_values.indexOf(vals[1])), fromIndex < 0 || toIndex < 0)) {
                    console.log("[filters] price range no longer valid");
                    return;
                }
                sliderData.update({ from: fromIndex, to: toIndex }), console.log("[filters] price range restored");
            }
        }
        function restoreSliderVals() {
            var sliderId, slidersSelector, $sliders;
            for (sliderId in sliderVals)
                sliderVals.hasOwnProperty(sliderId) &&
                    ((slidersSelector = "[" + selectors.sliderIdAttr + '="' + sliderId + '"]'),
                    ($sliders = $(selectors.slider).filter(slidersSelector)),
                    $sliders.each(function () {
                        setSliderVal(this, sliderVals[sliderId]);
                    }));
        }
        function toggleSortMenus(toggle) {
            var $sortUI = $(selectors.sortUi);
            $sortUI.toggle(toggle);
        }
        function getOrState(module) {
            var $module = module ? $(module) : $(selectors.module),
                $sliders = $module.find(selectors.slider),
                $checkboxes = $module.find(selectors.checkboxes),
                $orControls = $sliders.add($checkboxes),
                orState = !1;
            return (
                $orControls.each(function () {
                    var value = $(this).data("value");
                    value && value.length > 1 && (console.log("[filters] orState true", value), (orState = !0));
                }),
                console.log("[filters] orState", orState),
                orState
            );
        }
        function filtersPostAjax() {
            var $clone, orState;
            addCheckboxCounts(),
                hideEmptyFilters(),
                setSortActiveState(),
                fixCollectionsActiveState(),
                window.rfd && window.rfd.initSliders && window.rfd.initSliders($(selectors.slider)),
                window.rfd && window.rfd.initCheckboxes && window.rfd.initCheckboxes($(selectors.checkboxes)),
                restoreSliderVals(),
                window.rfd && window.rfd.sortTags && window.rfd.sortTags(),
                window.rfd && window.rfd.enableBtns && window.rfd.enableBtns(),
                window.rfd && window.rfd.vipSale && window.rfd.vipSale(),
                window.rfd && window.rfd.lazyPagReinit && window.rfd.lazyPagReinit(),
                window.rfd && window.rfd.reinitQuickAdd && window.rfd.reinitQuickAdd(),
                ($clone = $(".desktop-sortby").clone()),
                $(".desktop-sortby-placeholder").html($clone),
                console.log("[filters] add sort back"),
                (orState = getOrState()),
                toggleSortMenus(!orState);
        }
        function getRandom() {
            return Math.floor(Math.random() * 99999);
        }
        function updateSummary() {
            var $module = $(selectors.module).first(),
                $summary = $module.find(selectors.filterSummary),
                $summaryActive = $module.find(selectors.filterSummaryActive),
                $activeFilters = $module.find("[data-filter-checkbox], [data-filter-link]").filter(".is-active"),
                $sliders = $module.find(selectors.slider),
                activeSliders = !1;
            if (
                ($sliders.each(function () {
                    var $sum = $(this).closest(".filter-group__slider").find(".range-slider__selection-val");
                    this.value && this.value.length && (!$sum.length || $sum.text().trim() !== $sum.attr("data-none-val").trim()) && (activeSliders = !0);
                }),
                $summaryActive.empty(),
                !activeSliders && !$activeFilters.length)
            ) {
                $summary.attr("aria-hidden", !0);
                return;
            }
            $summary.attr("aria-hidden", !1),
                $activeFilters.each(function () {
                    var uniqueId = "filter-" + getRandom(),
                        tagName = $(this).attr("data-tag-name"),
                        activeLink = '<a class="link--tag capitalize display-inline-block" href="#' + uniqueId + '">' + tagName + "</a>";
                    $(this).attr("id", uniqueId), $summaryActive.append(activeLink);
                }),
                $sliders.each(function () {
                    var uniqueId = "filter-" + getRandom(),
                        prefix = $(this).attr("data-prefix-char"),
                        val = $(this).val(),
                        $sum = $(this).closest(".filter-group__slider").find(".range-slider__selection-val"),
                        rangeVals = val.split(";"),
                        rangeStr = prefix + rangeVals[0] + " - " + prefix + rangeVals[1],
                        $clearBtn = $(this).parent().find(".range-slider__clear"),
                        activeLink = '<a class="link--tag capitalize display-inline-block" href="#' + uniqueId + '">' + rangeStr + "</a>";
                    !val.length || ($sum.length && $sum.text().trim() === $sum.attr("data-none-val").trim()) || ($clearBtn.attr("id", uniqueId), $summaryActive.append(activeLink));
                });
        }
        function ajaxUpdateFilters(callback) {
            var $currentFilters = $(selectors.module),
                ajaxUrl = getFiltersAjaxUrl(filteredUrl);
            window.rfd && window.rfd.disableBtns && window.rfd.disableBtns(),
                console.log("[filters] updating filters...", ajaxUrl),
                console.time("[filters] update filters"),
                $.get(ajaxUrl, function (filterHtmlStr) {
                    var $updatedFilters = $(filterHtmlStr).find(selectors.module);
                    $currentFilters.replaceWith($updatedFilters);
                    var $filtersDrawer = $(selectors.filterDrawer);
                    $filtersDrawer.addClass("open"),
                        window.rfd && window.rfd.menuAccordionFunction && window.rfd.menuAccordionFunction(),
                        window.rfd && window.rfd.reinitQuickAdd && window.rfd.reinitQuickAdd(),
                        window.rfd && window.rfd.lazyPagReinit && window.rfd.lazyPagReinit(),
                        filtersFunction(),
                        filtersPostAjax(),
                        updateSummary(),
                        console.timeEnd("[filters] update filters"),
                        $.isFunction(callback) && callback();
                });
        }
        function getSearchURL(module) {
            var searchUrl = "/search?type=product&view=filter-results",
                queryVal = "",
                excludeTag = "",
                sortStr = "",
                allowedSorts = ["created-descending", "price-ascending", "price-descending", "title-ascending", "title-descending"],
                collectionHandle,
                $activefilterLinks,
                $sliders = $(module).find(selectors.slider),
                sliderVals2,
                $checkboxGroups = $(module).find(selectors.checkboxes),
                checkboxVals;
            return (
                sort &&
                    sort.query &&
                    allowedSorts.forEach(function (val) {
                        sort.query.search(val) !== -1 && (sortStr = val);
                    }),
                (searchUrl += "&q="),
                (collectionHandle = window.location.href.match(/collections\/([\w-]*)/)[1]),
                collectionHandle !== "all" && (queryVal = "tag%3A%22collection:" + collectionHandle + "%22+OR+tag%3A%22collection:%20" + collectionHandle + "%22"),
                ($activefilterLinks = $(module).find(selectors.filterLinks).filter(".is-active")),
                $activefilterLinks.each(function () {
                    var tagVal = $(this).attr("data-tag-value");
                    tagVal && (queryVal && (queryVal += "+AND+"), (queryVal += "tag%3A%22" + tagVal + "%22"));
                }),
                $sliders.each(function () {
                    (sliderVals2 = $(this).data("value")),
                        Array.isArray(sliderVals2) &&
                            sliderVals2.forEach(function (tagVal, index) {
                                var tagValEncoded = tagVal.replace(" ", "%20");
                                index === 0 ? (queryVal && (queryVal += "+AND+"), (queryVal += "tag%3A%22" + tagValEncoded + "%22")) : (queryVal && (queryVal += "+OR+"), (queryVal += "tag%3A%22" + tagValEncoded + "%22"));
                            });
                }),
                $checkboxGroups.each(function () {
                    (checkboxVals = $(this).data("value")),
                        Array.isArray(checkboxVals) &&
                            checkboxVals.forEach(function (tagVal, index, arr) {
                                var tagValEncoded = tagVal.replace(" ", "%20");
                                index === 0 ? (queryVal && (queryVal += "+AND+"), (queryVal += "tag%3A%22" + tagValEncoded + "%22")) : (queryVal && (queryVal += "+OR+"), (queryVal += "tag%3A%22" + tagValEncoded + "%22")), arr.length - 1;
                            });
                }),
                queryVal === "" ? queryVal : (excludeTag && (queryVal += "+NOT+tag%3A" + excludeTag), console.log("[filters] collectionHandle, sliderVals, checkboxVals", collectionHandle, sliderVals2, checkboxVals), searchUrl + queryVal)
            );
        }
        function getCollectionURL() {
            var destinationUrl;
            return !sort.query && !filteredUrl && !sort.cleared
                ? (console.log("[filters] selection reset"), (destinationUrl = window.location.pathname), destinationUrl)
                : !filteredUrl && sort.cleared
                ? (console.log("[filters] clear sort"), (destinationUrl = window.location.href.replace(/\??&?sort_by=.*?(&|$)/gi, "")), destinationUrl)
                : (sort.cleared && (filteredUrl = filteredUrl.replace(/\??&?sort_by=.*?(&|$)/gi, "")),
                  sort.query && !filteredUrl
                      ? ((destinationUrl = window.location.pathname + sort.query), console.log("[filters] only change sort", destinationUrl), destinationUrl)
                      : ((destinationUrl = filteredUrl.replace(/\??&?view=filters-only&?/gi, "")),
                        sort.query &&
                            (destinationUrl.indexOf("sort_by=") === -1
                                ? destinationUrl.indexOf("?") === -1
                                    ? (console.log("[filters] append sort"), (destinationUrl += sort.query))
                                    : (console.log("[filters] add sort"), (sort.query = sort.query.replace("?", "&")), (destinationUrl += sort.query))
                                : (console.log("[filters] replace sort"), (sort.query = sort.query.replace("?", "")), (destinationUrl = destinationUrl.replace(/sort_by=.*?(&|$)/gi, sort.query + "$1")))),
                        destinationUrl));
        }
        function resultsPostAjax() {
            var sections;
            window && window.picturefill && (window.picturefill(), console.log("[filters] refire picturefill")),
                window && window.objectFitPolyfill && (window.objectFitPolyfill(), console.log("[filters] refire objectFitPolyfill")),
                window.rfd && window.rfd.enableBtns && window.rfd.enableBtns(),
                (sections = new slate.Sections()),
                sections.register("product", window.theme.Product),
                console.log("[filters] refire product.js"),
                window.rfd && window.rfd.reinitQuickAdd && window.rfd.reinitQuickAdd(),
                typeof collectionPageMobileCarousel < "u" && $.isFunction(collectionPageMobileCarousel) && collectionPageMobileCarousel();
        }
        function getFilteredResults(queryUrl, callback) {
            var siteUrl = window.location.href.replace(window.location.pathname, "").replace(window.location.search, "").replace(window.location.hash, ""),
                queryUrlDefaultView = queryUrl.replace(/view=.*?&/, "");
            if (!queryUrl) {
                console.error("[filters] no valid queryUrl supplied");
                return;
            }
            window.rfd && window.rfd.disableBtns && window.rfd.disableBtns(),
                console.log("[filters] fetching results", siteUrl + queryUrlDefaultView),
                console.log("[filters] queryUrl", queryUrl),
                $.get(queryUrl, function (data) {
                    $.isFunction(callback) && callback(data), resultsPostAjax();
                });
        }
        function setFilteredResults(newHtml) {
            var $newHtml = $(newHtml),
                $results = $(selectors.filterResults),
                $pag = $(selectors.filterPag),
                $newResults = $newHtml.find(selectors.filterResults),
                $newPag = $newHtml.find(selectors.filterPag),
                orState = getOrState();
            $results.replaceWith($newResults);
            var filterCount = $(".filter-group .is-active:not([data-default-selected])").length;
            filterCount > 0 ? $("body").addClass("is-filtered") : $("body").removeClass("is-filtered"),
                console.log(sort.query, filteredUrl, checkboxesVals, sliderVals),
                updateGridCount(),
                $newPag.length && $pag.html($newPag.html()),
                console.log("[filters] updated results"),
                toggleSortMenus(!orState),
                window.rfd && window.rfd.lazyPagReinit && window.rfd.lazyPagReinit(),
                window.rfd && window.rfd.layoutGrid && window.rfd.layoutGrid(),
                $(".product-grid__item").addClass("filtered-item");
        }
        function isOnCanvas(elem) {
            var bounding = elem.getBoundingClientRect();
            return bounding.left >= 0 && bounding.right <= (window.innerWidth || document.documentElement.clientWidth);
        }
        function getApplyBtnState(module) {
            var applyState = !1,
                $applyBtn = $(module).find(selectors.applyBtn);
            return $applyBtn.length && $applyBtn.is(":visible") && isOnCanvas($applyBtn.get(0)) && (applyState = !0), applyState;
        }
        function handleSummaryActiveClick(e) {
            var sourceLink = $(this).attr("href");
            e.preventDefault(), $(sourceLink).trigger("click");
        }
        function initSummary() {
            $(document).on("click", "[data-filter-summary-active] a", handleSummaryActiveClick);
        }
        function getDestinationUrl(module) {
            var $module = $(module),
                destinationUrl,
                orState = getOrState($module);
            return orState ? (destinationUrl = getSearchURL($module)) : (destinationUrl = getCollectionURL()), console.log("[filters] destination url", destinationUrl), destinationUrl;
        }
        function updateResults(module) {
            var $module = $(module),
                destinationUrl = getDestinationUrl($module);
            if (!destinationUrl) {
                console.log("[filters] no query url", destinationUrl);
                return;
            }
            console.time("[filters] fetch results"),
                getFilteredResults(destinationUrl, function (data) {
                    console.timeEnd("[filters] fetch results"), setFilteredResults(data), updateSummary();
                });
        }
        function updateResultsIfNoApply($module) {
            var isApplyBtn = getApplyBtnState($module);
            isApplyBtn || updateResults($module);
        }
        function setCheckboxVal(checkboxGroup, checkboxVal) {
            var $checkboxGroup = $(checkboxGroup);
            $checkboxGroup.data("value", checkboxVal),
                checkboxVal.forEach(function (val) {
                    $checkboxGroup
                        .find('[data-tag-value="' + val + '"]')
                        .addClass("is-active")
                        .closest(".filter-group__item")
                        .addClass("is-active");
                });
        }
        function setSliderCounterparts(slider) {
            var sliderId = $(slider).attr(selectors.sliderIdAttr),
                sliderSelector = "[" + selectors.sliderIdAttr + '="' + sliderId + '"]',
                $sliderCounterparts = $(sliderSelector).not(slider),
                sliderVal = $(slider).val();
            $sliderCounterparts.each(function () {
                setSliderVal(this, sliderVal);
            });
        }
        function setCheckboxesCounterparts(checkboxGroup) {
            var id = $(checkboxGroup).attr(selectors.checkboxesIdAttr),
                value = $(checkboxGroup).data("value"),
                allSelector = "[" + selectors.checkboxesIdAttr + '="' + id + '"]',
                $counterparts = $(allSelector).not(checkboxGroup);
            console.log("[filters] updating counterparts", allSelector, $counterparts),
                $counterparts.each(function () {
                    setCheckboxVal(this, value);
                });
        }
        function handleRangeUpdate() {
            var $module = $(this).closest(selectors.module),
                sliderId = $(this).attr(selectors.sliderIdAttr),
                sliderVal = $(this).val(),
                orState = getOrState($module),
                isApplyBtn = getApplyBtnState($module);
            (sliderVals[sliderId] = sliderVal), setSliderCounterparts(this), toggleSortMenus(!orState), $module.length && !isApplyBtn && updateResults($module);
        }
        function handleCheckboxesUpdate(e) {
            var $module = $(this).closest(selectors.module),
                checkboxesId = $(this).attr(selectors.checkboxesIdAttr),
                checkboxesVal = $(this).data("value"),
                orState = getOrState($module),
                isApplyBtn = getApplyBtnState($module);
            e.preventDefault(), (checkboxesVals[checkboxesId] = checkboxesVal), setCheckboxesCounterparts(this), toggleSortMenus(!orState), $module.length && !isApplyBtn && updateResults($module);
        }
        function handleSortSelect(e) {
            var $allLinks = $(selectors.filterSort).filter('[data-href="' + $(this).attr("data-href") + '"]'),
                $filterGroup = $allLinks.closest(selectors.filterGroup),
                sortVal = $(this).text(),
                $module = $(this).closest(selectors.module);
            if ((e.preventDefault(), $(this).hasClass("is-active"))) {
                $allLinks.removeClass("is-active"),
                    (sort.query = null),
                    (sort.cleared = !0),
                    $filterGroup.find(selectors.selectToggle).text(defaultSelectText),
                    $(selectors.sortBtn).text(defaultSelectText),
                    $filterGroup.find(".filter-group__select").removeClass("is-open");
                return;
            }
            (sort.cleared = !1),
                (sort.query = $(this).attr("data-href")),
                $filterGroup.find(".is-active").removeClass("is-active"),
                $allLinks.addClass("is-active"),
                $filterGroup.find(selectors.selectToggle).text(sortVal),
                $(selectors.sortBtn).text(sortVal),
                $filterGroup.find(".filter-group__select").removeClass("is-open"),
                console.log("[filters]", sort.query),
                $module.length || ($module = $(this).closest(selectors.group).find(selectors.module)),
                $module.length && updateResultsIfNoApply($module),
                handleApplyClick(e);
        }
        function handleCheckboxClick(e) {
            e.preventDefault(), (filteredUrl = $(this).attr("data-href")), ajaxUpdateFilters(), handleApplyClick(e);
        }
        function handleFilterClick(e) {
            var tagVal = $(this).attr("data-tag-value"),
                allLinksSelector = "[" + selectors.filterLinksValAttr + '="' + tagVal + '"]',
                $allLinks = $(selectors.filterLinks).filter(allLinksSelector),
                $module = $(this).closest(selectors.module);
            e.preventDefault(),
                (filteredUrl = $(this).attr("href")),
                $allLinks.each(function () {
                    var $filterGroup = $(this).closest(selectors.filterGroup);
                    $filterGroup.find(".is-active").removeClass("is-active"), $(this).addClass("is-active");
                }),
                ajaxUpdateFilters(),
                updateResultsIfNoApply($module);
        }
        function handleApplyClick(e) {
            var $module = $(this).closest(selectors.module);
            e.preventDefault(),
                updateResults($module),
                $("body").hasClass("is-offcanvas-open")
                    ? setTimeout(function () {
                          $(".js-offcanvas-close").click();
                      }, 1e3)
                    : setTimeout(function () {
                          $('[data-toggle-target="#filters-dropdown"]').click();
                      }, 1e3),
                window.rfd && window.rfd.lazyPagReinit && window.rfd.lazyPagReinit();
        }
        function handleResetClick(e) {
            var $module = $(this).closest(selectors.module);
            e.preventDefault(),
                console.log("[filters] reset"),
                $(selectors.filterLinks).removeClass("is-active"),
                $(selectors.filterGroupItem).removeClass("is-active"),
                $(selectors.sortUi).find(".is-active").removeClass("is-active").find("[data-default-selected]").addClass("is-active"),
                $(selectors.selectToggle).text(defaultSelectText),
                $(selectors.sortBtn).text(defaultSelectText),
                (sort.query = null),
                (filteredUrl = null),
                (checkboxesVals = {}),
                (sliderVals = {}),
                ajaxUpdateFilters(function () {
                    updateResults($module);
                });
        }
        function addCheckboxCounts() {
            var THRESHOLD = 7;
            $(".filter-group__list").each(function () {
                var count = $(this).find(".filter-group__item").length;
                $(this).toggleClass("is-small-list", count < THRESHOLD);
            });
        }
        function init() {
            $(selectors.module).length &&
                (hideEmptyFilters(),
                setSortActiveState(),
                fixCollectionsActiveState(),
                initSummary(),
                addCheckboxCounts(),
                $(document).on("click", selectors.filterLinks, handleFilterClick),
                $(document).on("click", selectors.checkbox, handleCheckboxClick),
                $(document).on("click", selectors.filterSort, handleSortSelect),
                $(document).on("click", selectors.resetBtn, handleResetClick),
                $(document).on("click", selectors.applyBtn, handleApplyClick),
                $(document).on("rangeSliderUpdate", selectors.slider, handleRangeUpdate),
                $(document).on("checkboxesUpdate", selectors.checkboxes, handleCheckboxesUpdate));
        }
        init();
    }),
    (function () {
        var selectors = {
            checkboxes: "[data-checkboxes]",
            checkbox: "[data-checkbox]",
            activeClass: "is-active",
            tagValueAttr: "data-tag-value",
            summary: "[data-checkboxes-summary]",
            summaryList: "[data-checkboxes-summary-list]",
            count: "[data-checkboxes-count]",
            clear: "[data-checkboxes-clear]",
        };
        function updateSummary(checkboxGroup) {
            var $checkboxGroup = $(checkboxGroup),
                currentVal = $checkboxGroup.data("value"),
                $summary = $checkboxGroup.find(selectors.summary),
                $summaryList = $checkboxGroup.find(selectors.summaryList),
                $count = $checkboxGroup.find(selectors.count);
            if (($count.text(currentVal.length), $summaryList.empty(), !currentVal.length)) {
                $summary.attr("aria-hidden", !0);
                return;
            }
            $summary.attr("aria-hidden", !1),
                currentVal.forEach(function (val, ind, arr) {
                    var valStr = val.replace(/^.*?:/, "").trim();
                    $summaryList.append('<span class="capitalize">' + valStr + "</span>"), ind < arr.length - 1 && $summaryList.append(", ");
                }),
                console.log("[checkboxes] updated summary");
        }
        function setValFromDOM(checkboxGroup) {
            var $checkboxGroup = $(checkboxGroup),
                currentVal = [],
                $checkboxBoxes = $checkboxGroup.find(selectors.checkbox);
            $checkboxBoxes.filter(".is-active").each(function () {
                currentVal.push($(this).attr("data-tag-value"));
            }),
                $checkboxGroup.data("value", currentVal),
                updateSummary($checkboxGroup),
                console.log("[checkboxes] set value to", currentVal),
                $("filters__active-list").text(currentVal);
        }
        function updateVal($checkboxGroup, value) {
            $checkboxGroup.data("value", value), updateSummary($checkboxGroup), $checkboxGroup.trigger("checkboxesUpdate");
        }
        function toggleVal(checkboxGroup, value) {
            var $checkboxGroup = $(checkboxGroup),
                currentVal = $checkboxGroup.data("value"),
                valueIndex,
                toggle;
            if (!$.isArray(currentVal)) {
                console.error("[checkboxes] invalid value (should be Array)", currentVal);
                return;
            }
            (valueIndex = currentVal.indexOf(value)),
                (toggle = valueIndex < 0),
                toggle ? currentVal.push(value) : currentVal.splice(valueIndex, 1),
                updateVal($checkboxGroup, currentVal),
                console.log("[checkboxes] set value to", $checkboxGroup.data("value"));
        }
        function clearVal(checkboxGroup) {
            var $checkboxGroup = $(checkboxGroup);
            updateVal($checkboxGroup, []), $checkboxGroup.find(".is-active").removeClass("is-active");
        }
        function handleCheckboxClick(e) {
            var $checkboxGroup = $(this).closest(selectors.checkboxes),
                checkboxVal = $(this).attr(selectors.tagValueAttr);
            e.preventDefault(), $(this).toggleClass(selectors.activeClass), $(this).closest(".filter-group__item").toggleClass(selectors.activeClass), toggleVal($checkboxGroup, checkboxVal);
        }
        function handleClearClick(e) {
            var $checkboxGroup = $(this).closest(selectors.checkboxes);
            e.preventDefault(), clearVal($checkboxGroup);
        }
        function initCheckboxes(checkboxes) {
            var $checkboxes;
            checkboxes ? ($checkboxes = $(checkboxes)) : ($checkboxes = $(selectors.checkboxes)),
                $checkboxes.each(function () {
                    setValFromDOM(this), ($checkboxes = $(this).find(selectors.checkbox)), $checkboxes.on("click", handleCheckboxClick), $(this).find(selectors.clear).on("click", handleClearClick);
                });
        }
        function init() {
            var $checkboxes = $(selectors.checkboxes);
            $checkboxes.length && initCheckboxes($checkboxes);
        }
        $(document).on("ready", init), (window.rfd = window.rfd || {}), (window.rfd.initCheckboxes = initCheckboxes);
    })(),
    (function () {
        gsap.registerPlugin(ScrollToPlugin);
        function initGallery() {
            var galleries = document.querySelectorAll('.js-block[data-block="gallery"]');
            galleries.forEach(function (galleryMod) {
                "use strict";
                var gallery = galleryMod,
                    header = document.querySelector(".pdp-header"),
                    headerBackLink = document.querySelector(".pdp-header__back"),
                    main = document.querySelector(".pdp-col--main"),
                    title = main.querySelector(".pdp-main__title"),
                    close = main.querySelector(".js-main-pdp-close-trigger"),
                    btns = main.querySelector(".pdp-main__btns"),
                    addBtn = btns.querySelector(".pdp-main__add-btn"),
                    touchGallery = gallery.querySelector(".pdp-gallery__gallery"),
                    list = gallery.querySelector(".pdp-gallery__gallery-list"),
                    items = gallery.querySelectorAll(".pdp-gallery__gallery-item"),
                    itemsL = items.length,
                    dots = gallery.querySelector(".pdp-gallery__gallery-dots"),
                    sizeGuideBtn = document.querySelector(".js-size-guide-trigger"),
                    galeryWrap = document.querySelector(".pdp-gallery__desktop-wrap"),
                    galeryZoomButton = document.querySelectorAll(".pdp-header .js-zoom, .mobile-nav__close"),
                    mobileGalery = document.querySelector(".pdp-col--gallery"),
                    mobileGaleryFigures = mobileGalery.querySelectorAll("figure"),
                    initialised = !1,
                    scrolling = !1,
                    scrollTimeout = null,
                    zooming = !1,
                    zoomStart = { scale: 1, deltaX: 0, deltaY: 0 },
                    zoomImageElementScale = 1,
                    zoomImageElement = galeryWrap.querySelector(".pdp-gallery__gallery-item:nth-child(1) figure img"),
                    current = 0,
                    scroll = { prev: 0, current: 0, start: 0, new: 0, max: 0 },
                    touchScrollPos = { prev: 0, new: 0 },
                    scrollThreshold = 50,
                    toNext = !0,
                    itemHeight = items[0].offsetHeight,
                    calculatedGalleryHeight = 0,
                    animFrame = null,
                    animating = !1,
                    anchorScrollGsap = null,
                    galleryOpen = !0,
                    pageWidth = 0;
                (scroll.max = itemHeight * (itemsL - 1)),
                    checkBackLink(),
                    (window.onbeforeunload = function () {
                        window.scrollTo(0, 0);
                    });
                var font = new FontFaceObserver("Gilroy", { weight: 700 });
                touchGallery.addEventListener("touchmove", mobileEvent),
                    touchGallery.addEventListener("touchend", stopScrolling),
                    window.addEventListener("touchstart", startPageTouch),
                    window.addEventListener("touchend", stopPageTouch),
                    window.addEventListener("resize", setSizes),
                    close.addEventListener("click", showGallery),
                    btns.addEventListener("click", checkAddBtn),
                    sizeGuideBtn && sizeGuideBtn.addEventListener("click", hideGallery),
                    galeryWrap.addEventListener("touchstart", startZoom),
                    galeryWrap.addEventListener("touchmove", changeZoom),
                    galeryWrap.addEventListener("touchend", stopZoom),
                    galeryZoomButton.forEach((el) => {
                        el.addEventListener("click", () => {
                            (zoomStart.scale = 1),
                                setImageTransform(0, 0, 1),
                                document.querySelector("body").classList.toggle("zoom-mode"),
                                setTimeout(startScrolling, 300),
                                setTimeout(anchorScroll, 310),
                                setTimeout(() => (scrolling = !1), 350);
                        });
                    }),
                    font.load().then(function () {
                        window.innerWidth < 1023 ? setSizes() : (pageWidth = window.innerWidth);
                    }, null);
                const distance = (event) => Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY),
                    setImageTransform = (deltaX, deltaY, scale) => {
                        const isScaling = scale !== !1;
                        let realScale = scale;
                        isScaling
                            ? ((zoomStart.maxDeltaX = (zoomImageElement.offsetWidth * scale - zoomImageElement.offsetWidth) / 2), (zoomStart.maxDeltaY = (zoomImageElement.offsetHeight * scale - zoomImageElement.offsetHeight) / 2))
                            : (realScale = zoomStart.scale);
                        let realDeltaX = deltaX === !1 ? zoomStart.deltaX || 0 : deltaX,
                            realDeltaY = deltaY === !1 ? zoomStart.deltaY || 0 : deltaY;
                        if (Math.abs(realDeltaX) > zoomStart.maxDeltaX) {
                            if (!isScaling) return;
                            realDeltaX = Math.sign(realDeltaX) * zoomStart.maxDeltaX;
                        }
                        if (Math.abs(realDeltaY) > zoomStart.maxDeltaY) {
                            if (!isScaling) return;
                            realDeltaY = Math.sign(realDeltaY) * zoomStart.maxDeltaY;
                        }
                        const transform = `translate3d(${realDeltaX || 0}px, ${realDeltaY || 0}px, 0) scale(${realScale})`;
                        (zoomImageElement.style.display = "block"),
                            (zoomImageElement.style.transform = transform),
                            (zoomImageElement.style.WebkitTransform = transform),
                            (zoomStart.lastDeltaX = realDeltaX),
                            (zoomStart.lastDeltaY = realDeltaY),
                            (zoomStart.lastScale = realScale);
                    };
                function startZoom(event) {
                    (zoomImageElement = galeryWrap.querySelector(`.pdp-gallery__gallery-item:nth-child(${current + 1}) figure img`)),
                        event.touches.length === 2 && document.querySelector("body").classList.contains("zoom-mode")
                            ? (event.preventDefault(), (zooming = !0), (zoomStart.distance = distance(event)))
                            : event.touches.length === 1 && document.querySelector("body").classList.contains("zoom-mode") && ((zoomStart.startX = event.touches[0].pageX), (zoomStart.startY = event.touches[0].pageY));
                }
                function stopZoom(event) {
                    (zooming = !1),
                        (zoomStart.deltaX = zoomStart.lastDeltaX || 0),
                        (zoomStart.deltaY = zoomStart.lastDeltaY || 0),
                        (zoomStart.scale = zoomStart.lastScale || 1),
                        zoomStart.scale > 2.5 && ((zoomStart.scale = 2.5), setImageTransform(zoomStart.deltaX, zoomStart.deltaY, zoomStart.scale));
                }
                function changeZoom(event) {
                    if (event.touches.length === 2 && zooming) {
                        event.preventDefault();
                        let scale;
                        event.scale ? (scale = event.scale) : (scale = distance(event) / zoomStart.distance), (zoomImageElementScale = Math.min(Math.max(scale * zoomStart.scale, 1), 4)), setImageTransform(!1, !1, zoomImageElementScale);
                    } else if (document.querySelector("body").classList.contains("zoom-mode") && zoomStart.scale != 1) {
                        event.preventDefault();
                        const moveX = event.touches[0].pageX - zoomStart.startX,
                            moveY = event.touches[0].pageY - zoomStart.startY,
                            deltaX = zoomStart.deltaX + moveX,
                            deltaY = zoomStart.deltaY + moveY;
                        setImageTransform(deltaX, deltaY, !1);
                    }
                }
                function checkBackLink() {
                    document.referrer.includes("https://cultgaia.com") || headerBackLink.setAttribute("href", "https://cultgaia.com/collections/all");
                }
                function setSizes() {
                    if (pageWidth !== window.innerWidth) {
                        if (((pageWidth = window.innerWidth), pageWidth >= 1024)) {
                            stopAnimate(), list.style.removeProperty("transform"), main.style.removeProperty("margin-top"), gallery.style.removeProperty("height");
                            return;
                        }
                        var pageHeight = window.innerHeight,
                            titleHeight = title.offsetHeight,
                            btnsHeight = btns.offsetHeight,
                            btnsMargin = 16;
                        (calculatedGalleryHeight = pageHeight - titleHeight - btnsHeight - btnsMargin),
                            (main.style.marginTop = calculatedGalleryHeight + "px"),
                            (gallery.style.height = calculatedGalleryHeight + "px"),
                            initialised || setTimeout(enforceScroll, 100);
                    }
                }
                function enforceScroll() {
                    (initialised = !0), window.scrollTo(0, 0);
                }
                function startScrolling(startY) {
                    if (zooming || zoomStart.scale != 1) {
                        stopAnimate();
                        return;
                    }
                    anchorScrollGsap && anchorScrollGsap.kill(),
                        (scrolling = !0),
                        (itemHeight = items[0].offsetHeight),
                        (scroll.max = itemHeight * (itemsL - 1)),
                        (scroll.prev = scroll.current),
                        (scroll.start = startY),
                        (animating = !0),
                        (animFrame = window.requestAnimationFrame(animate));
                }
                function stopScrolling() {
                    if (pageWidth < 1024) {
                        (scrolling = !1), (scroll.current = scroll.new);
                        var newCurrent = scroll.current / itemHeight,
                            difference = newCurrent - current;
                        (difference > -0.1 && difference < 0.1) ||
                            (difference > 0 && toNext && current < itemsL - 1
                                ? (current = Math.ceil(newCurrent))
                                : difference > 0 && toNext && current >= itemsL - 1
                                ? hideGallery()
                                : difference < 0 && !toNext && current > 0 && (current = Math.floor(newCurrent))),
                            anchorScroll();
                    }
                }
                function startPageTouch(e) {
                    pageWidth >= 1024 || (touchScrollPos.prev = window.pageYOffset);
                }
                function stopPageTouch(e) {
                    if (!(pageWidth >= 1024)) {
                        var pageScroll = window.pageYOffset;
                        galleryOpen
                            ? pageScroll > 0 && pageScroll < scrollThreshold
                                ? showGallery()
                                : pageScroll >= scrollThreshold && pageScroll < calculatedGalleryHeight && hideGallery()
                            : touchScrollPos.prev > pageScroll && pageScroll < 0 && showGallery();
                    }
                }
                function showGallery(e) {
                    e && e.preventDefault(),
                        pageWidth < 1024 &&
                            (header.classList.remove("scrollable"),
                            gallery.classList.remove("hidden"),
                            main.classList.remove("open"),
                            gsap.to(gallery, { y: 0, duration: 0.5 }),
                            gsap.to(main, { marginTop: calculatedGalleryHeight, duration: 0.5, ease: "power2.out" }),
                            gsap.to(window, { scrollTo: { y: 0 }, duration: 0.5, ease: "power2.out" }),
                            (galleryOpen = !0));
                }
                function hideGallery() {
                    pageWidth < 1024 &&
                        !document.querySelector("body").classList.contains("zoom-mode") &&
                        (header.classList.add("scrollable"),
                        gallery.classList.add("hidden"),
                        main.classList.add("open"),
                        gsap.to(main, { marginTop: 0, duration: 0.5, ease: "power2.out" }),
                        gsap.to(window, { scrollTo: { y: 0 }, duration: 0.5, ease: "power2.out", onComplete: stopAnimate }),
                        (galleryOpen = !1));
                }
                function mobileEvent(e) {
                    if (zooming || zoomStart.scale != 1) {
                        stopAnimate();
                        return;
                    }
                    pageWidth < 1024 && (scrolling || startScrolling(e.touches[0].clientY), (scroll.new = scroll.prev + (scroll.start - e.touches[0].clientY)), (toNext = scroll.new > scroll.current));
                }
                function checkAddBtn(e) {
                    e.target === btns && addBtn.getAttribute("disabled") && galleryOpen && pageWidth < 1024 && hideGallery();
                }
                function anchorScroll() {
                    dots.setAttribute("data-current", current), (anchorScrollGsap = gsap.to(scroll, { new: current * itemHeight, duration: 0.5 }));
                }
                function animate() {
                    (scroll.current += (scroll.new - scroll.current) * 0.3),
                        (scroll.current = scroll.current > 1 ? scroll.current : 0),
                        (scroll.current = scroll.current < scroll.max - 1 ? scroll.current : scroll.max),
                        (list.style.transform = "translateY(-" + scroll.current + "px)"),
                        animating && (animFrame = window.requestAnimationFrame(animate));
                }
                function stopAnimate() {
                    (animating = !1), animFrame && window.cancelAnimationFrame(animFrame);
                }
            });
        }
        initGallery();
    })();
function collectionPageMobileCarousel() {
    gsap.registerPlugin(ScrollToPlugin);
    function initGallery(galleries2) {
        galleries2.forEach(function (galleryMod) {
            "use strict";
            var gallery = galleryMod,
                touchGallery = gallery.querySelector("ul.gallery"),
                items = gallery.querySelectorAll("ul.gallery li"),
                itemsL = items.length,
                dots = gallery.querySelector("ul.dots");
            gallery.classList.add("initialized");
            var scrolling = !1,
                touching = !1,
                current = 0,
                scroll = { prev: 0, current: 0, start: 0, new: 0, max: 0 },
                touchScrollPos = { prev: 0, new: 0 },
                toNext = !0,
                itemWidth = items[0].offsetWidth,
                animFrame = null,
                animating = !1,
                anchorScrollGsap = null,
                pageWidth = 0;
            (scroll.max = itemWidth * (itemsL - 1)),
                touchGallery.addEventListener("touchmove", mobileEvent),
                touchGallery.addEventListener("touchend", stopScrolling),
                touchGallery.addEventListener("touchstart", startPageTouch),
                touchGallery.addEventListener("touchend", stopPageTouch);
            function startScrolling(startX) {
                anchorScrollGsap && anchorScrollGsap.kill(),
                    stopAnimate(),
                    (scrolling = !0),
                    (itemWidth = items[0].getBoundingClientRect ? items[0].getBoundingClientRect().width : items[0].offsetWidth),
                    (scroll.max = itemWidth * (itemsL - 1)),
                    (scroll.prev = scroll.current),
                    (scroll.start = startX),
                    (animating = !0),
                    (touching = !0),
                    (window.collectionAnimFrame = window.requestAnimationFrame(animate));
            }
            function stopScrolling() {
                if (pageWidth < 1024) {
                    (scrolling = !1), (scroll.current = scroll.new);
                    var newCurrent = scroll.current / itemWidth,
                        difference = newCurrent - current;
                    (difference > -0.1 && difference < 0.1) ||
                        (difference > 0 && toNext && current < itemsL - 1
                            ? (current = Math.ceil(newCurrent))
                            : (difference > 0 && toNext && current >= itemsL - 1) || (difference < 0 && !toNext && current > 0 && (current = Math.floor(newCurrent)))),
                        anchorScroll();
                }
            }
            function startPageTouch(e) {
                pageWidth >= 1024 || ((touching = !0), (touchScrollPos.prev = window.pageXOffset));
            }
            function stopPageTouch(e) {
                pageWidth >= 1024 || (touching = !1);
            }
            function mobileEvent(e) {
                pageWidth < 1024 && (scrolling || startScrolling(e.touches[0].clientX), (scroll.new = scroll.prev + (scroll.start - e.touches[0].clientX)), (toNext = scroll.new > scroll.current));
            }
            function anchorScroll() {
                dots.setAttribute("data-current", current), (anchorScrollGsap = gsap.to(scroll, { new: current * itemWidth, duration: 0.2 }));
            }
            function animate() {
                if (
                    ((scroll.current += (scroll.new - scroll.current) * 0.5),
                    (scroll.current = scroll.current > 1 ? scroll.current : 0),
                    (scroll.current = scroll.current < scroll.max - 1 ? scroll.current : scroll.max),
                    (touchGallery.style.transform = "translateX(-" + scroll.current + "px)"),
                    scroll.current == scroll.prevScrollValue && !touching)
                ) {
                    anchorScrollGsap && anchorScrollGsap.kill(), stopAnimate(), scroll.current == scroll.max && ((touchGallery.style.transform = null), (scroll.current = 0), (current = 0), dots.setAttribute("data-current", current));
                    return;
                }
                (scroll.prevScrollValue = scroll.current), animating && (window.collectionAnimFrame = window.requestAnimationFrame(animate));
            }
            function stopAnimate() {
                (animating = !1), window.collectionAnimFrame && window.cancelAnimationFrame(window.collectionAnimFrame);
            }
        });
    }
    const galleries = document.querySelectorAll(".product-grid__item .js-collection-carousel:not(.initialized)");
    galleries.length && initGallery(galleries);
}
collectionPageMobileCarousel(),
    (function () {
        function init() {
            $(document).on("touchstart click", '.template-product .shopify-product-form .variant-wrapper--content input[type="radio"]', function (e) {
                var radio = $('.variant-wrapper--content input[type="radio"]:checked'),
                    value = $(radio).val(),
                    parent = $(".pdp-main__variation--size .pdp-main__selected-variation");
                $(parent).text(value);
            });
        }
        init();
    })(),
    (function () {
        var selectors = {
            module: "[data-lazy-selectors]",
            option: "[data-lazy-selectors-option]",
            group: "[data-lazy-selectors-group]",
            optionPriceAttr: "data-lazy-selectors-option-price",
            variantIdAttr: "data-lazy-selectors-option",
            addBtn: "button[data-quick-add-to-cart]",
            addBtnIdAttr: "data-quick-add-to-cart",
            activeClass: "is-active",
            addToCartText: "[data-ctrl-text]",
            fakeOption: "[data-fake-lazy-selectors-option]",
            fakeGroup: "[data-fake-lazy-selectors-group]",
            fakeVariantIdAttr: "data-fake-lazy-selectors-option",
        };
        function toggleGroupOption(option) {
            var $option = $(option),
                $group = $option.closest(selectors.group),
                $groupOptions = $group.find(selectors.option),
                $module = $option.closest(selectors.module),
                $addBtn = $module.find(selectors.addBtn),
                $groups = $module.find(selectors.group),
                alteredMoneyFormat = window.theme.moneyFormat,
                variantIds = "",
                subtotal = 0,
                $selectedVariantId = $option.attr(selectors.variantIdAttr),
                $fakeGroup = $(selectors.fakeGroup),
                $fakeGroupOptions = $fakeGroup.find(selectors.fakeOption);
            $option.hasClass(selectors.activeClass)
                ? ($groupOptions.removeClass(selectors.activeClass), $("[" + selectors.fakeVariantIdAttr + '="' + $selectedVariantId + '"]').removeClass(selectors.activeClass))
                : ($groupOptions.removeClass(selectors.activeClass),
                  $option.addClass(selectors.activeClass),
                  $("[" + selectors.fakeVariantIdAttr + '="' + $selectedVariantId + '"]')
                      .addClass(selectors.activeClass)
                      .parent()
                      .siblings()
                      .children()
                      .removeClass(selectors.activeClass)),
                $groups.each(function (index) {
                    var $thisGroupOptions = $(this).find(selectors.option),
                        $active = $thisGroupOptions.filter("." + selectors.activeClass),
                        price = $active.attr(selectors.optionPriceAttr);
                    $active.length && ((variantIds += index > 0 ? "," : ""), (variantIds += $active.attr(selectors.variantIdAttr)), price && (subtotal += parseInt(price, 10)));
                }),
                (alteredMoneyFormat = alteredMoneyFormat.replace("amount_with_comma_separator", "amount")),
                (alteredMoneyFormat = alteredMoneyFormat.replace("amount_with_apostrophe_separator", "amount")),
                $addBtn.attr(selectors.addBtnIdAttr, variantIds),
                variantIds ? $addBtn.html(window.theme.strings.addToCart + " - Total: " + slate.Currency.formatMoney(subtotal, alteredMoneyFormat)) : $addBtn.html(window.theme.strings.selectSizes);
        }
        function toggleSingleOption(option) {
            var $option = $(option),
                variantId = $option.attr(selectors.variantIdAttr),
                $module = $option.closest(selectors.module),
                $addBtn = $module.find(selectors.addBtn),
                $options = $module.find(selectors.option);
            if ($option.hasClass(selectors.activeClass)) {
                $option.removeClass(selectors.activeClass), $addBtn.attr(selectors.addBtnIdAttr, "").prop("disabled", !0).children(selectors.addToCartText).html(window.theme.strings.selectSize);
                return;
            }
            $options.removeClass(selectors.activeClass),
                $option.addClass(selectors.activeClass),
                $addBtn.attr(selectors.addBtnIdAttr, variantId).prop("disabled", !1).children(selectors.addToCartText).html(window.theme.strings.addToCart),
                $option.data("pre-order") !== void 0 && $addBtn.children(selectors.addToCartText).html(window.theme.strings.preOrder);
        }
        function toggleFakeGroupOption(option) {
            var $option = $(option),
                $group = $option.closest(selectors.fakeGroup),
                $groupOptions = $group.find(selectors.fakeOption),
                $selectedVariantId = $option.attr(selectors.fakeVariantIdAttr);
            $option.hasClass(selectors.activeClass) ? $groupOptions.removeClass(selectors.activeClass) : ($groupOptions.removeClass(selectors.activeClass), $option.addClass(selectors.activeClass)),
                $("[" + selectors.variantIdAttr + '="' + $selectedVariantId + '"]').click();
        }
        function handleOptionClick(e) {
            var $group = $(this).closest(selectors.group);
            e.preventDefault(), $group.length ? toggleGroupOption(this) : toggleSingleOption(this);
        }
        function handleFakeClick(e) {
            e.preventDefault(), toggleFakeGroupOption(this);
        }
        function init() {
            $("body").on("click", selectors.option, handleOptionClick), $("body").on("click", selectors.fakeOption, handleFakeClick);
        }
        init();
    })(),
    (function () {
        function debounce(func) {
            var _arguments = arguments,
                _this = this,
                wait = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500,
                immediate = arguments.length > 2 ? arguments[2] : void 0,
                timeout;
            return function () {
                var context = _this,
                    args = _arguments,
                    later = function () {
                        (timeout = null), immediate || func.apply(context, args);
                    },
                    callNow = immediate && !timeout;
                clearTimeout(timeout), (timeout = setTimeout(later, wait)), callNow && func.apply(context, args);
            };
        }
        function initScroll() {
            var cont = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document,
                body = document.body,
                win = window,
                els = cont.querySelectorAll("[data-view]"),
                lazyImages = cont.querySelectorAll("[data-lazy]");
            function scrollWatcher() {
                var defaultOffsetPercentage = 20,
                    offsets = [],
                    points = [],
                    lazyPoints = [],
                    lazyImageSrcs = [],
                    scrollValue = 0,
                    prevScrollValue = 0,
                    scrolled = !1,
                    scrolledUp = !1,
                    scrollAnim = null,
                    pageHeight = window.innerHeight,
                    initialGetVars = function () {
                        scrollValue = win.pageYOffset;
                        for (var x3 = 0; x3 < els.length; x3++) {
                            var customOffset = els[x3].getAttribute("data-view-offset") !== null ? parseInt(els[x3].getAttribute("data-view-offset")) : defaultOffsetPercentage,
                                customPercentage = customOffset / 100;
                            offsets.push(customPercentage), points.push(scrollValue + els[x3].getBoundingClientRect().top + pageHeight * customPercentage);
                        }
                        for (var _x = 0; _x < lazyImages.length; _x++) lazyPoints.push(Math.round(scrollValue) + lazyImages[_x].getBoundingClientRect().top - pageHeight), lazyImageSrcs.push(lazyImages[_x].getAttribute("data-lazy"));
                    },
                    getVars = function () {
                        (pageHeight = window.innerHeight), (points = []), (lazyPoints = []), (scrollValue = win.pageYOffset);
                        for (var x3 = 0; x3 < els.length; x3++) points.push(scrollValue + els[x3].getBoundingClientRect().top + pageHeight * offsets[x3]);
                        for (var _x2 = 0; _x2 < lazyImages.length; _x2++) lazyPoints.push(Math.round(scrollValue) + lazyImages[_x2].getBoundingClientRect().top - pageHeight);
                    };
                initialGetVars(), window.addEventListener("resize", debounce(getVars, 500));
                for (var tracker = [], lazyTracker = [], x2 = 0; x2 < els.length; x2++) tracker.push(0);
                for (var _x3 = 0; _x3 < lazyImages.length; _x3++) lazyTracker.push(0);
                var maxFps = 15,
                    now,
                    delta,
                    then = Date.now(),
                    interval = 1e3 / maxFps,
                    watchScroll = function watchScroll2() {
                        if (((now = Date.now()), (delta = now - then), delta > interval)) {
                            scrollValue = win.pageYOffset;
                            for (var scroll = scrollValue + pageHeight, scrollLazy = scrollValue, _x4 = 0; _x4 < tracker.length; _x4++)
                                tracker[_x4] !== 1 && scroll >= points[_x4] && ((tracker[_x4] = 1), els[_x4].setAttribute("data-view", !0));
                            for (var _x5 = 0; _x5 < lazyTracker.length; _x5++)
                                lazyTracker[_x5] !== 1 && scrollLazy >= lazyPoints[_x5] && ((lazyTracker[_x5] = 1), lazyImages[_x5].setAttribute("src", lazyImageSrcs[_x5]), lazyImages[_x5].removeAttribute("data-lazy"));
                            scrolled && scrollValue < 10 ? ((scrolled = !1), body.classList.remove("scrolled")) : !scrolled && scrollValue >= 10 && ((scrolled = !0), body.classList.add("scrolled")),
                                scrollValue > prevScrollValue
                                    ? ((prevScrollValue = scrollValue), scrolledUp && ((scrolledUp = !1), body.classList.remove("scrolled-up")))
                                    : !scrolledUp && scrollValue < prevScrollValue - 20
                                    ? ((scrolledUp = !0), body.classList.add("scrolled-up"))
                                    : scrolledUp && (prevScrollValue = scrollValue),
                                (then = now - (delta % interval));
                        }
                        scrollAnim = requestAnimationFrame(watchScroll2);
                    };
                scrollAnim = requestAnimationFrame(watchScroll);
            }
            return scrollWatcher();
        }
        function resetScrollElements() {
            for (var els = document.querySelectorAll("[data-view]"), length = els.length, i = 0; i < length; i++) els[i].setAttribute("data-view", !1);
        }
        var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };
        function disableScroll() {
            window.addEventListener && window.addEventListener("DOMMouseScroll", preventDefault, !1),
                (window.onwheel = preventDefault),
                (window.onmousewheel = document.onmousewheel = preventDefault),
                (window.ontouchmove = preventDefault),
                (document.onkeydown = preventDefaultForScrollKeys);
        }
        function enableScroll() {
            window.removeEventListener && window.removeEventListener("DOMMouseScroll", preventDefault, !1),
                (window.onmousewheel = document.onmousewheel = null),
                (window.onwheel = null),
                (window.ontouchmove = null),
                (document.onkeydown = null);
        }
        function preventDefault(e) {
            (e = e || window.event), e.preventDefault && e.preventDefault(), (e.returnValue = !1);
        }
        function preventDefaultForScrollKeys(e) {
            if (keys[e.keyCode]) return preventDefault(e), !1;
        }
        initScroll(), resetScrollElements(), disableScroll(), enableScroll();
    })(),
    (function () {
        function sizeGuideInit() {
            var sizeGuideBlocks = document.querySelectorAll('.js-block[data-block="size-guide"]');
            sizeGuideBlocks.forEach(function (sizeMod) {
                var sizeGuide = sizeMod,
                    trigger = sizeGuide.querySelector(".js-size-guide-trigger"),
                    categories = sizeGuide.querySelectorAll(".pdp-main__size-guide-category button"),
                    guideWrapper = sizeGuide.querySelector(".pdp-main__size-guide-chart-wrap"),
                    wraps = sizeGuide.querySelectorAll(".pdp-main__size-guide-table-wrap"),
                    inners = sizeGuide.querySelectorAll(".pdp-main__size-guide-table-inner"),
                    tables = sizeGuide.querySelectorAll(".pdp-main__size-guide-table-scroll"),
                    tablesL = tables.length,
                    scrollbars = sizeGuide.querySelectorAll(".pdp-main__size-guide-scrollbar span"),
                    closeBtn = sizeGuide.querySelector(".pdp-main__size-guide-close"),
                    maxCategories = categories.length,
                    clickEvents = [],
                    scrollEvents = [],
                    activeGuide = 0;
                (inners[activeGuide].style.height = tables[activeGuide].offsetHeight - 40 + "px"), (guideWrapper.style.height = wraps[activeGuide].offsetHeight + "px");
                for (var x2 = 0; x2 < maxCategories; x2++) clickEvents.push(changeCategory.bind(this, x2));
                for (var x2 = 0; x2 < maxCategories; x2++) scrollEvents.push(updateScroll.bind(this, x2));
                for (var _x = 0; _x < maxCategories; _x++) categories[_x].addEventListener("click", clickEvents[_x]);
                for (var x2 = 0; x2 < tablesL; x2++) tables[x2].addEventListener("scroll", scrollEvents[x2]);
                for (var x2 = 0; x2 < tablesL; x2++) wraps[x2].addEventListener("click", scrollOnClick);
                trigger.addEventListener("click", openSizeGuide), closeBtn.addEventListener("click", closeSizeGuide), checkScrollableTables(), window.addEventListener("resize", checkScrollableTables);
                function changeCategory(x3) {
                    x3 !== activeGuide &&
                        (sizeGuide.setAttribute("data-active-guide", x3),
                        (activeGuide = x3),
                        (inners[activeGuide].style.height = tables[activeGuide].offsetHeight - 40 + "px"),
                        (guideWrapper.style.height = wraps[activeGuide].offsetHeight + "px"));
                }
                function checkScrollableTables() {
                    for (var _x2 = 0; _x2 < tablesL; _x2++) wraps[_x2].setAttribute("data-no-scroll", tables[_x2].scrollWidth <= tables[_x2].clientWidth);
                }
                function updateScroll(x3) {
                    var maxScroll = tables[activeGuide].scrollWidth - tables[activeGuide].clientWidth,
                        currentScroll = tables[activeGuide].scrollLeft,
                        scrollDecimal = currentScroll / maxScroll;
                    scrollbars[activeGuide].style.transform = "scaleX(" + scrollDecimal + ")";
                }
                function openSizeGuide(e) {
                    e && e.preventDefault(),
                        (activeGuide = 0),
                        setTimeout(function () {
                            categories[0].focus();
                        }, 200),
                        sizeGuide.setAttribute("data-active-guide", activeGuide),
                        sizeGuide.setAttribute("data-size-guide", "true"),
                        (inners[activeGuide].style.height = tables[activeGuide].offsetHeight - 40 + "px"),
                        (guideWrapper.style.height = wraps[activeGuide].offsetHeight + "px");
                }
                function closeSizeGuide(e) {
                    e && e.preventDefault(),
                        (activeGuide = 0),
                        setTimeout(function () {
                            trigger.focus();
                        }, 200),
                        sizeGuide.setAttribute("data-active-guide", 0),
                        sizeGuide.setAttribute("data-size-guide", "false"),
                        (guideWrapper.style.height = "0px");
                }
                function scrollOnClick(e) {
                    const scrollElement = e.currentTarget.querySelector(".pdp-main__size-guide-table-scroll"),
                        ksScrollElement = e.currentTarget.querySelector(".ks-table-wrapper");
                    var maxScroll = scrollElement.clientWidth,
                        scrollPercentage = maxScroll / 2,
                        ksMaxScroll = scrollElement.clientWidth,
                        ksScrollPercentage = ksMaxScroll / 2;
                    scrollElement && scrollElement.scrollBy({ top: 0, left: +scrollPercentage, behavior: "smooth" }), ksScrollElement && ksScrollElement.scrollBy({ top: 0, left: +ksScrollPercentage, behavior: "smooth" });
                }
            });
        }
        sizeGuideInit();
    })(),
    (function () {
        function upsellInit() {
            var upsells = document.querySelectorAll('.js-block[data-block="upsell"]');
            upsells.forEach(function (upsellMod) {
                for (var upsell = upsellMod, triggers = upsell.querySelectorAll(".js-upsell-trigger"), triggersL = triggers.length, setActiveEvents = [], current = 0, x2 = 0; x2 < triggersL; x2++)
                    setActiveEvents.push(setActiveEvent.bind(this, x2));
                for (var _x = 0; _x < triggersL; _x++) triggers[_x].addEventListener("click", setActiveEvents[_x]);
                function setActiveEvent(x3, e) {
                    e && e.preventDefault(), x3 !== current && (triggers[current].classList.remove("active"), triggers[x3].classList.add("active"), upsell.setAttribute("data-upsell-carousel", x3 + 1), (current = x3));
                }
            });
        }
        function upsellToggleReinit() {
            upsellInit();
        }
        upsellInit(), (window.rfd = window.rfd || {}), (window.rfd.upsellToggleReinit = upsellToggleReinit);
    })();
var loadProductRecommendationsIntoSection = function () {
    console.debug("loadProductRecommendationsIntoSection");
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    if (productRecommendationsSection !== null) {
        var productId = productRecommendationsSection.dataset.productId,
            limit = productRecommendationsSection.dataset.limit,
            requestUrl = "/recommendations/products?section_id=product-recommendations&limit=" + limit + "&product_id=" + productId,
            request = new XMLHttpRequest();
        request.open("GET", requestUrl),
            (request.onload = function () {
                if (request.status >= 200 && request.status < 300) {
                    var container = document.createElement("div");
                    (container.innerHTML = request.response), (productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML);
                }
                window.rfd && window.rfd.dragCarouselReinit && window.rfd.dragCarouselReinit(), window.rfd && window.rfd.upsellToggleReinit && window.rfd.upsellToggleReinit();
            }),
            request.send();
    }
};
document.addEventListener("shopify:section:load", function (event) {
    event.detail.sectionId === "product-recommendations" && loadProductRecommendationsIntoSection();
}),
    loadProductRecommendationsIntoSection();
const loadCartProductRecommendations = function () {
    const sectionId = "product-recommendations-cart",
        sectionSelector = ".minicart-upsells";
    console.debug("loadCartProductRecommendations");
    const sectionEl = document.querySelector(sectionSelector);
    if (!sectionEl) return;
    const mostRecentlyAddedProductId = document.querySelector("[data-cart-item]")?.dataset.productId;
    if (!mostRecentlyAddedProductId) return;
    const fetchUrl = window.Shopify.routes.root + `recommendations/products?section_id=${sectionId}&limit=10&product_id=${mostRecentlyAddedProductId}`;
    console.debug("loadCartProductRecommendations loading", { sectionEl, fetchUrl }),
        fetch(fetchUrl)
            .then((response) => response.text())
            .then((text) => {
                console.debug("loadCartProductRecommendations building new html from response");
                const newContainerEl = document.createElement("div");
                newContainerEl.innerHTML = text;
                const newSectionEl = newContainerEl.querySelector(sectionSelector);
                newSectionEl && newSectionEl.innerHTML.trim().length && (sectionEl.innerHTML = newSectionEl.innerHTML),
                    console.debug("loadCartProductRecommendations re-initializing carousels"),
                    window.rfd && window.rfd.dragCarouselReinit && window.rfd.dragCarouselReinit();
            })
            .catch((e) => {
                console.error(e);
            });
};
document.addEventListener("shopify:section:load", function (event) {
    event.detail.sectionId === "cart" && loadCartProductRecommendations();
}),
    loadCartProductRecommendations(),
    (function () {
        function quickAddInit() {
            var quickAddBlocks = document.querySelectorAll('.js-block[data-block="quick-add"]'),
                quickAddBlocksContainer = document.querySelectorAll(".products")[0];
            quickAddBlocks.forEach(function (quickAddMod) {
                var quickAddBlock = quickAddMod,
                    addBtn = quickAddBlock.querySelector(".products__listing-add-btn"),
                    quickAddOption = quickAddBlock.querySelector(".products__listing-quick-add-item:first-child a"),
                    productDetails = quickAddBlock.querySelector(".products__listing-details a"),
                    saveBtn = quickAddBlock.querySelector(".products__listing-save-btn"),
                    closeBtn = quickAddBlock.querySelector(".products__listing-quick-add-title button"),
                    open = "false";
                typeof addBtn < "u" && addBtn != null && addBtn.addEventListener("click", openQuickOptions),
                    typeof quickAddBlock < "u" && quickAddBlock != null && quickAddBlock.addEventListener("mouseleave", resetQuickAdd),
                    typeof productDetails < "u" && productDetails != null && productDetails.addEventListener("focusin", resetQuickAdd),
                    typeof saveBtn < "u" && saveBtn != null && saveBtn.addEventListener("focusin", resetQuickAdd),
                    typeof closeBtn < "u" && closeBtn != null && closeBtn.addEventListener("click", resetQuickAdd);
                function openQuickOptions(e) {
                    e.preventDefault(), open === "false" && ((open = "true"), quickAddBlock.setAttribute("data-quick-add", open), quickAddBlocksContainer.setAttribute("data-quick-add-list", open), quickAddOption.focus());
                }
                function resetQuickAdd() {
                    (open = "false"), quickAddBlock.setAttribute("data-quick-add", open), quickAddBlocksContainer.setAttribute("data-quick-add-list", open), closeSelectSizeModal();
                }
            });
        }
        function reinitQuickAdd() {
            quickAddInit();
        }
        quickAddInit(), (window.rfd = window.rfd || {}), (window.rfd.reinitQuickAdd = reinitQuickAdd);
    })(),
    (function cartupsellFunction() {
        function cartupsellInit() {
            var cartUpsells = document.querySelectorAll('.js-block[data-block="cart-upsell"]');
            cartUpsells.forEach(function (upsellMod) {
                typeof cartUpsells < "u" &&
                    cartUpsells != null &&
                    upsellMod.addEventListener("click", function (event) {
                        upsellMod.classList.add("active"), Shopify.Cart.GiftWrap.set();
                    });
            });
        }
        cartupsellInit(), (window.rfd = window.rfd || {}), (window.rfd.cartupsellFunction = cartupsellFunction);
    })(),
    (function () {
        function dragCarouselInitSingle(dragMod) {
            "use strict";
            var carousel = dragMod,
                inner = carousel.querySelector(".carousel__inner"),
                carouselRows = parseInt(carousel.getAttribute("data-carousel-rows"), 10),
                edgeResistance = parseInt(carousel.getAttribute("data-edge-resistance"), 10),
                list = inner.querySelector(".carousel__list"),
                dragIcon = carousel.querySelector(".carousel-drag"),
                prevButton = carousel.querySelector(".carousel-arrows__arrow--prev"),
                nextButton = carousel.querySelector(".carousel-arrows__arrow--next"),
                progressbar = carousel.querySelector(".carousel-progress__bar"),
                arrows = carousel.querySelector(".carousel-arrows"),
                snap = carousel.getAttribute("data-snap") === "true",
                draggable = null,
                listWidth = 0,
                maxX = 0,
                current = 0,
                start = !0,
                end = !1,
                snapPoints = [],
                items = list.querySelectorAll("li"),
                itemsL = items.length,
                images = list.querySelectorAll(".pdp-upsell__listing-image img"),
                imagesL = images.length,
                dragIconFollowing = !1,
                dragIconVisible = !1,
                dragIconAnimFrame = null,
                position = { current: { x: window.innerWidth * 0.7, y: 140, top: 0 }, next: { x: 0, y: 0, top: 0 } };
            updateAttributes(), setTimeout(setWidth, 1e3), window.addEventListener("resize", debounce(setWidth, 500));
            var observer = new MutationObserver(setWidth);
            observer.observe(list, { attributes: !1, childList: !0, subtree: !1 });
            for (var x2 = 0; x2 < imagesL; x2++) observer.observe(images[x2], { attributes: !0, childList: !1, subtree: !1 });
            function setWidth() {
                var mutations = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                draggable &&
                    (dragIcon &&
                        (dragIconAnimFrame && window.cancelAnimationFrame(dragIconAnimFrame),
                        list.removeEventListener("mousemove", setDragPos),
                        list.removeEventListener("mouseleave", hideDrag),
                        prevButton && prevButton.removeEventListener("click", movePrevious),
                        nextButton && nextButton.removeEventListener("click", moveNext)),
                    draggable[0].kill(),
                    (draggable = null)),
                    mutations && mutations[0] && (mutations[0].type === "childList" ? ((items = list.querySelectorAll("li")), (itemsL = items.length)) : mutations[0].type),
                    (listWidth = 0),
                    (snapPoints = []),
                    snap && snapPoints.push(0);
                for (var _x = 0; _x < itemsL; _x++) {
                    var _style = window.getComputedStyle ? getComputedStyle(items[_x], null) : items[_x].currentStyle,
                        itemWidth = items[_x].offsetWidth + parseInt(_style.marginLeft) + parseInt(_style.marginRight);
                    snap && snapPoints.push((listWidth + itemWidth) * -1),
                        window.innerWidth < 768
                            ? (itemsL < 3 && (carouselRows = 1), itemsL > 2 && itemsL < 5 && carouselRows > 1 ? (listWidth = itemWidth * 3) : _x < itemsL / (carouselRows || 1) && (listWidth += itemWidth))
                            : (listWidth += itemWidth);
                }
                window.innerWidth > listWidth ? arrows?.classList.add("hidden") : arrows?.classList.remove("hidden");
                var style = window.getComputedStyle ? getComputedStyle(inner, null) : inner.currentStyle;
                (listWidth += parseInt(style.paddingLeft) + parseInt(style.paddingRight)), (list.style.width = listWidth + "px"), createDraggable();
            }
            function createDraggable() {
                if (((maxX = inner.offsetWidth - listWidth), maxX > 0)) {
                    carousel.setAttribute("data-init", !1);
                    return;
                }
                dragIcon && (list.addEventListener("mousemove", setDragPos), list.addEventListener("mouseleave", hideDrag)),
                    prevButton && prevButton.addEventListener("click", movePrevious),
                    nextButton && nextButton.addEventListener("click", moveNext),
                    carousel.setAttribute("data-init", !0),
                    snap &&
                        (snapPoints.push(maxX),
                        snapPoints.sort(function (a, b) {
                            return b - a;
                        })),
                    (draggable = Draggable.create(list, { type: "x", edgeResistance: edgeResistance || 0.8, bounds: { minX: 0, maxX }, inertia: !0, snap: snap ? snapPoints : !1, onDrag: drag, onDragEnd: dragEnd }));
            }
            function drag() {
                dragIconFollowing && stopDrag(), progressbar && gsap.to(progressbar, { scaleX: this.x / maxX, duration: 0.6 });
            }
            function dragEnd() {
                progressbar && gsap.to(progressbar, { scaleX: this.endX / maxX, duration: 0.6 }),
                    snap && (current = closestIndex(snapPoints, this.endX)),
                    (start = !1),
                    (end = !1),
                    this.endX === 0 || this.endX === -0 ? (start = !0) : this.endX / maxX === 1 && (end = !0),
                    updateAttributes();
            }
            function showDrag() {
                (dragIconVisible = !0), dragIcon.classList.add("visible"), dragIconAnimFrame || (dragIconAnimFrame = window.requestAnimationFrame(updateDragPos));
            }
            function hideDrag() {
                (dragIconVisible = !1), dragIcon.classList.remove("visible"), dragIconAnimFrame && window.cancelAnimationFrame(dragIconAnimFrame), (dragIconAnimFrame = null);
            }
            function startDrag() {
                (dragIconFollowing = !0), (dragIconVisible = !0), (dragIconAnimFrame = window.requestAnimationFrame(updateDragPos)), dragIcon.classList.add("visible");
            }
            function stopDrag() {
                (dragIconFollowing = !1),
                    list.removeEventListener("mousemove", setDragPos),
                    list.removeEventListener("mouseleave", hideDrag),
                    dragIconAnimFrame && window.cancelAnimationFrame(dragIconAnimFrame),
                    (dragIconAnimFrame = null),
                    dragIcon.classList.remove("visible");
            }
            function setDragPos(e) {
                dragIconFollowing || startDrag(), dragIconVisible || showDrag();
                var mPos = { x: e.clientX, y: e.clientY };
                position.next = mPos;
            }
            function updateDragPos() {
                var rect = carousel.getBoundingClientRect();
                (position.next.top = rect.top),
                    (position.current.x += (position.next.x - rect.left - position.current.x) * 0.15),
                    (position.current.y += (position.next.y - position.current.y) * 0.15),
                    (position.current.top += (position.next.top - position.current.top) * 0.15),
                    (dragIcon.style.transform = "translateX(" + position.current.x + "px) translateY(" + (position.current.y - position.current.top) + "px)"),
                    (dragIconAnimFrame = window.requestAnimationFrame(updateDragPos));
            }
            function movePrevious() {
                (start = !1),
                    (end = !1),
                    current > 0 && (current--, gsap.to(list, { x: snapPoints[current], duration: 0.6 }), progressbar && gsap.to(progressbar, { scaleX: snapPoints[current] / maxX, duration: 0.6 }), current === 0 && (start = !0)),
                    updateAttributes();
            }
            function moveNext() {
                (start = !1),
                    (end = !1),
                    snapPoints[current + 1] > maxX
                        ? (current++, gsap.to(list, { x: snapPoints[current], duration: 0.6 }), progressbar && gsap.to(progressbar, { scaleX: snapPoints[current] / maxX, duration: 0.6 }))
                        : end || ((end = !0), current++, gsap.to(list, { x: maxX, duration: 0.6 }), progressbar && gsap.to(progressbar, { scaleX: 1, duration: 0.6 })),
                    updateAttributes();
            }
            function updateAttributes() {
                carousel.setAttribute("data-start", start), carousel.setAttribute("data-end", end);
            }
            function closestIndex(array, num) {
                var i = 0,
                    minDiff = 1e3,
                    ans;
                for (i in array) {
                    var m = Math.abs(num - array[i]);
                    m < minDiff && ((minDiff = m), (ans = parseInt(i)));
                }
                return ans;
            }
            function debounce(func) {
                var _arguments = arguments,
                    _this = this,
                    wait = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500,
                    immediate = arguments.length > 2 ? arguments[2] : void 0,
                    timeout;
                return function () {
                    var context = _this,
                        args = _arguments,
                        later = function () {
                            (timeout = null), immediate || func.apply(context, args);
                        },
                        callNow = immediate && !timeout;
                    clearTimeout(timeout), (timeout = setTimeout(later, wait)), callNow && func.apply(context, args);
                };
            }
        }
        function dragCarouselInit() {
            gsap.registerPlugin(Draggable), gsap.registerPlugin(InertiaPlugin);
            var dragCarousel2 = document.querySelectorAll('.js-block[data-block="drag-carousel"]');
            dragCarousel2.forEach((x2) => dragCarouselInitSingle(x2));
        }
        function dragCarouselReinit() {
            dragCarouselInit();
            var quick_buttons = document.querySelectorAll(".open_quick_button"),
                quick_close_buttons = document.querySelectorAll(".quick-close");
            quick_buttons.forEach(function (button) {
                button.addEventListener("click", function () {
                    document.querySelectorAll(".quick-close").forEach(function (element) {
                        element.parentElement.classList.add("display_none");
                    });
                    var valorData = button.dataset.id;
                    quick_pop = document.querySelector("#q_" + valorData);
                    var _style = window.getComputedStyle ? getComputedStyle(quick_pop, null) : quick_pop.currentStyle,
                        itemHeight = quick_pop.offsetHeight;
                    console.log(itemHeight), quick_pop.classList.remove("display_none");
                });
            }),
                quick_close_buttons.forEach(function (button) {
                    button.addEventListener("click", function () {
                        var valorData = button.dataset.id;
                        (quick_pop = document.querySelector("#q_" + valorData)), quick_pop.classList.add("display_none");
                    });
                });
        }
        dragCarouselInit(), (window.rfd = window.rfd || {}), (window.rfd.dragCarouselInit = dragCarouselInit), (window.rfd.dragCarouselReinit = dragCarouselReinit);
    })(),
    (function () {
        function manifestoInit() {
            var manifestos = document.querySelectorAll('.js-block[data-block="manifesto"]');
            manifestos.forEach(function (manifestoMod) {
                for (
                    var manifesto2 = manifestoMod,
                        gallery = manifesto2.querySelector(".manifesto__gallery"),
                        list = manifesto2.querySelector(".manifesto__list"),
                        items = manifesto2.querySelectorAll(".manifesto__item"),
                        itemsL = items.length,
                        visible = !1,
                        animating = !1,
                        animFrame = null,
                        position = { current: { x: window.innerWidth / 2, y: 400, top: 0 }, next: { x: 0, y: 0, top: 0 } },
                        updateGalleryEvents = [],
                        x2 = 0;
                    x2 < itemsL;
                    x2++
                )
                    updateGalleryEvents.push(updateGallery.bind(void 0, x2));
                list.addEventListener("mouseenter", showGallery), list.addEventListener("mouseleave", hideGallery), manifesto2.addEventListener("mousemove", setGalleryPos);
                for (var _x = 0; _x < itemsL; _x++) items[_x].addEventListener("mouseenter", updateGalleryEvents[_x]);
                function showGallery() {
                    visible || (animating || startAnimating(), (visible = !0), gallery.classList.add("visible"));
                }
                function hideGallery() {
                    visible && (animating && stopAnimating(), (visible = !1), gallery.classList.remove("visible"));
                }
                function updateGallery(x3, e) {
                    gallery.setAttribute("data-current", x3 + 1);
                }
                function setGalleryPos(e) {
                    var mPos = { x: e.clientX, y: e.clientY };
                    position.next = mPos;
                }
                function startAnimating() {
                    (animating = !0), (animFrame = window.requestAnimationFrame(setPosition));
                }
                function stopAnimating() {
                    (animating = !1), animFrame && window.cancelAnimationFrame(animFrame), (animFrame = null);
                }
                function setPosition() {
                    (position.next.top = manifesto2.getBoundingClientRect().top),
                        (position.current.x += (position.next.x - position.current.x) * 0.03),
                        (position.current.y += (position.next.y - position.current.y) * 0.03),
                        (position.current.top += (position.next.top - position.current.top) * 0.1),
                        (gallery.style.transform = "translateX(" + position.current.x + "px) translateY(" + (position.current.y - position.current.top) + "px)"),
                        (animFrame = window.requestAnimationFrame(setPosition));
                }
            });
        }
        manifestoInit();
    })(),
    (function layoutSort() {
        function layoutSortInit() {
            var layoutSort2 = document.querySelectorAll('.js-block[data-block="layout-sort"]');
            layoutSort2.forEach(function (layoutSortMod) {
                var layoutSort3 = layoutSortMod,
                    selectElementWrap = layoutSort3.querySelector(".layout-sort__select-element"),
                    selectElement = selectElementWrap.querySelector("#layout-sort"),
                    selectOptions = selectElement.querySelectorAll("option[value]"),
                    selectOptionsL = selectOptions.length,
                    dropdown = layoutSort3.querySelector(".layout-sort__dropdown"),
                    dropdownItems = dropdown.querySelectorAll("li"),
                    dropdownItemsL = dropdownItems.length,
                    currentSortIndex = layoutSort3.getAttribute("data-sort");
                selectElementWrap.addEventListener("click", openDropdown), dropdown.addEventListener("mouseleave", closeDropdown), selectElement.addEventListener("change", applyNewSortingMethod);
                function openDropdown() {
                    window.innerWidth < 1240 || layoutSort3.classList.add("open");
                }
                function closeDropdown() {
                    layoutSort3.classList.remove("open");
                }
                const handleSortClick = (e) => {
                    var index = e.target.getAttribute("data-index");
                    if (currentSortIndex === index) {
                        closeDropdown();
                        return;
                    }
                    (selectElement.value = selectOptions[index].value), (currentSortIndex = index), console.log({ currentSortIndex, selectOptions, index, layoutSort: layoutSort3 });
                };
                for (let x2 = 0; x2 < dropdownItemsL; x2++);
                function update() {
                    layoutSort3.setAttribute("data-sort", currentSortIndex), applyNewSortingMethod();
                }
                function applyNewSortingMethod() {
                    closeDropdown();
                }
            });
        }
        layoutSortInit(), (window.rfd = window.rfd || {}), (window.rfd.layoutSort = layoutSort);
    })(),
    (function layoutGrid() {
        function layoutGridInit() {
            var layoutGrid2 = document.querySelectorAll('.js-block[data-block="layout-grid"]');
            layoutGrid2.forEach(function (layoutGridMod) {
                var layoutGrid3 = layoutGridMod,
                    trigger2Grid = layoutGrid3.querySelector(".layout-sort__column-count-trigger--2"),
                    trigger3Grid = layoutGrid3.querySelector(".layout-sort__column-count-trigger--3"),
                    triggerGalleryGrid = layoutGrid3.querySelector(".layout-sort__column-count-trigger--gallery"),
                    products = document.querySelector(".products__inner > .cols"),
                    currentGrid = products.getAttribute("data-d-cols"),
                    urlString = window.location.search,
                    urlParams = new URLSearchParams(urlString),
                    currentGridOverride = urlParams.get("cols");
                currentGridOverride && !currentGrid && document.body.setAttribute("data-d-cols", currentGridOverride),
                    trigger2Grid.addEventListener("click", setTo2Grid),
                    trigger3Grid.addEventListener("click", setTo3Grid),
                    triggerGalleryGrid.addEventListener("click", setToGalleryGrid);
                function setTo2Grid(e) {
                    e.preventDefault(), (currentGrid = "2"), update();
                }
                function setTo3Grid(e) {
                    e.preventDefault(), (currentGrid = "3"), update();
                }
                function once(fn, context) {
                    var result;
                    return function () {
                        return fn && ((result = fn.apply(context || this, arguments)), (fn = null)), result;
                    };
                }
                var runLazyPagOnce = (function () {
                    var executed = !1;
                    return function () {
                        executed || ((executed = !0), window.rfd && window.rfd.loadNextPage && window.rfd.loadNextPage());
                    };
                })();
                function setToGalleryGrid(e) {
                    e.preventDefault(), (currentGrid = "gallery"), runLazyPagOnce(), update();
                }
                function update() {
                    document.body.setAttribute("data-d-cols", currentGrid);
                }
            });
        }
        layoutGridInit(), (window.rfd = window.rfd || {}), (window.rfd.layoutGrid = layoutGrid);
    })(),
    (function () {
        gsap.registerPlugin(SplitText);
        function SplitHeadingInit() {
            (heading = document.querySelectorAll('.js-block[data-block="split-heading"]')),
                heading.forEach(function (headingMod) {
                    var heading2 = headingMod,
                        splitType = heading2.getAttribute("data-split"),
                        fontFace = heading2.getAttribute("data-fontface"),
                        nested = heading2.getAttribute("data-nested") === "true",
                        splitHeading = null,
                        splitHeadingNested = null,
                        font = new FontFaceObserver(fontFace, { weight: 400 });
                    window.addEventListener("resize", debounce(resetSplits, 1e3)),
                        font.load().then(function () {
                            applyHeadingSplit();
                        }, null);
                    function applyHeadingSplit() {
                        (splitHeading = new SplitText(heading2, { type: splitType })),
                            nested && (splitHeadingNested = new SplitText(heading2, { type: splitType })),
                            setTimeout(function () {
                                heading2.classList.add("split");
                            }, 50);
                    }
                    function resetSplits() {
                        splitHeading.split(), splitHeadingNested && splitHeadingNested.split();
                    }
                    function debounce(func) {
                        var _arguments = arguments,
                            _this = this,
                            wait = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500,
                            immediate = arguments.length > 2 ? arguments[2] : void 0,
                            timeout;
                        return function () {
                            var context = _this,
                                args = _arguments,
                                later = function () {
                                    (timeout = null), immediate || func.apply(context, args);
                                },
                                callNow = immediate && !timeout;
                            clearTimeout(timeout), (timeout = setTimeout(later, wait)), callNow && func.apply(context, args);
                        };
                    }
                });
        }
        SplitHeadingInit();
    })(),
    (function () {
        function formsInit() {
            var forms2 = document.querySelectorAll('.js-block[data-block="form"]');
            forms2.forEach(function (formMod) {
                function handleInputEdit() {
                    for (var form = this.block, editBtns = form.querySelectorAll(".js-input-edit"), i = 0; i < editBtns.length; i++) {
                        var editBtn = editBtns[i];
                        editBtn.addEventListener("click", function (e) {
                            var btn = e.currentTarget,
                                btnType = btn.getAttribute("data-type"),
                                input = btn.previousElementSibling,
                                disabledState = input.disabled;
                            e.preventDefault(),
                                (input.disabled = !disabledState),
                                (btn.textContent = disabledState ? "Save" : "Edit"),
                                disabledState && input.focus(),
                                btnType === "password" && (input.type = disabledState ? "text" : "password");
                        });
                    }
                }
                function handleAddressEdit() {
                    for (var form = this.block, editBtns = form.querySelectorAll(".js-address-edit"), deleteBtns = form.querySelectorAll(".js-address-delete"), i = 0; i < editBtns.length; i++) {
                        var editBtn = editBtns[i];
                        editBtn.addEventListener("click", function (e) {
                            var btn = e.currentTarget,
                                addressEl = btn.parentNode.parentNode,
                                textarea = addressEl.querySelector(".js-address-input"),
                                paragraph = addressEl.querySelector(".js-address-text"),
                                disabledState = textarea.disabled,
                                addressValue = textarea.value.replace(/\n/g, "<br/>");
                            (textarea.disabled = !disabledState), (btn.textContent = disabledState ? "Save" : "Edit"), disabledState ? textarea.focus() : (paragraph.innerHTML = addressValue);
                        });
                    }
                    for (var _i = 0; _i < deleteBtns.length; _i++) {
                        var deleteBtn = deleteBtns[_i];
                        deleteBtn.addEventListener("click", function (e) {
                            alert("Are you sure you want to delete this address?");
                        });
                    }
                }
                handleInputEdit(), handleAddressEdit();
            });
        }
        formsInit();
    })(),
    (function () {
        function listingVideoInit() {
            var listingVideoBlocks = document.querySelectorAll('.js-block[data-block="listing-video"]');
            listingVideoBlocks.forEach(function (videoMod) {
                var listingVideoBlock = videoMod,
                    video = listingVideoBlock.querySelector("video"),
                    open = !1;
                typeof video < "u" && video != null && (listingVideoBlock.addEventListener("mouseenter", showVideo), listingVideoBlock.addEventListener("mouseleave", hideVideo));
                function showVideo() {
                    open || ((open = !0), listingVideoBlock.setAttribute("data-video", open), video.play(0));
                }
                function hideVideo() {
                    open && ((open = !1), listingVideoBlock.setAttribute("data-video", open), video.pause());
                }
            });
        }
        listingVideoInit();
        function reinitListingVideo() {
            listingVideoInit();
        }
        (window.rfd = window.rfd || {}), (window.rfd.reinitListingVideo = reinitListingVideo);
    })(),
    $(function () {
        var currentAjaxRequest = null,
            searchForms = $('form[action="/search"]').each(function () {
                var form = $(this).closest("form"),
                    input = $(this).find('input[name="q"]'),
                    resultsList = form.find(".main-nav__result-list"),
                    mobileList = form.find(".mobile-nav__result-list"),
                    resultsStacked = form.find(".main-nav__list--search"),
                    resetBtn = $(this).find('button[type="reset"]'),
                    headers = $(this).find("p.tag"),
                    top = $(this).find(".main-nav__col--search"),
                    term = $(this).val();
                $(resetBtn).click(function () {
                    resultsList.hide(), resultsStacked.hide(), $(headers).hide(), $(top).hide();
                });
                var offSet = input.position().top + input.innerHeight();
                $('<ul class="search-results"></ul>').appendTo($(this)).hide(),
                    $(headers).hide(),
                    $(top).hide(),
                    input.attr("autocomplete", "off").bind("keyup change", function () {
                        var term2 = $(this).val(),
                            form2 = $(this).closest("form"),
                            searchURL = "/search?type=product&q=" + term2,
                            resultsList2 = form2.find(".main-nav__result-list"),
                            mobileList2 = form2.find(".mobile-nav__result-list"),
                            mobileCarousel = form2.find(".mobile-nav__search-results .js-block"),
                            resultsStacked2 = form2.find(".main-nav__list--search");
                        term2.length > 3 &&
                            term2 != $(this).attr("data-old-term") &&
                            ($(this).attr("data-old-term", term2),
                            currentAjaxRequest?.abort(),
                            (currentAjaxRequest = $.getJSON(searchURL + "&view=json", function (data) {
                                resultsList2.empty(),
                                    mobileList2.empty(),
                                    resultsStacked2.empty(),
                                    data.results_count == 0
                                        ? ($(top).show(),
                                          resultsList2.html('<p class="xs upper">No results found for "' + term2 + '" </p>'),
                                          mobileCarousel.html('<p class="xs upper">No results found for "' + term2 + '" </p>'),
                                          resultsList2.fadeIn(200))
                                        : (window.rfd && window.rfd.dragCarouselReinit && window.rfd.dragCarouselReinit(),
                                          $(headers).show(),
                                          $(top).show(),
                                          $.each(data.results, function (index, item) {
                                              var link = $("<a></a>").attr("href", item.url),
                                                  stack = $("<a></a>").attr("href", item.url);
                                              link.append('<img class="lazyloaded loadbox" alt="' + item.title + '" width="120" height="178" alt="' + item.title + '" src="' + item.thumbnail + '" />'),
                                                  link.append('<p class="xs upper">' + item.title + "<br />" + item.price + "</p>"),
                                                  stack.append(item.title),
                                                  link.wrap("<li></li>"),
                                                  stack.wrap("<li></li>"),
                                                  resultsList2.append(link.parent()),
                                                  mobileList2.append(link.parent()),
                                                  resultsStacked2.append(stack.parent());
                                          }),
                                          data.results_count > 8 && resultsList2.append('<div class="main-nav__search-count"><a href="' + searchURL + '" class="breadcrumb">See all results (' + data.results_count + ")</a></div>"),
                                          data.results_count > 4 && mobileCarousel.append('<div class="main-nav__search-count"><a href="' + searchURL + '" class="breadcrumb">See all results (' + data.results_count + ")</a></div>"),
                                          resultsList2.fadeIn(550),
                                          mobileList2.fadeIn(550),
                                          resultsStacked2.fadeIn(550));
                            })));
                    });
            });
        $("body").bind("click", function () {
            $(".search-results").hide();
        });
    }),
    (function () {
        function videoFuncInit() {
            var videos = document.querySelectorAll('.js-block[data-block="video"]');
            videos.forEach(function (videoMod) {
                var video = videoMod,
                    vimeoID = video.getAttribute("data-id"),
                    vimeoMobileID = video.getAttribute("data-mobile-id"),
                    embed = video.querySelector(".js-video-embed"),
                    play = video.querySelector(".js-video-play"),
                    fullScreen = video.querySelector(".js-video-full-screen"),
                    sound = video.querySelector(".js-video-sound");
                if (vimeoID == 0) return;
                var vimeoInstance = null,
                    videoPlaying = !1,
                    videoMuted = !0,
                    videoAspectRatio = 0;
                play.addEventListener("click", toggleVideo), fullScreen.addEventListener("click", setfullScreen), sound.addEventListener("click", toggleSound), createEmbed();
                function createEmbed() {
                    (vimeoInstance = new Vimeo.Player(embed, { controls: !1, id: window.innerWidth < 768 && vimeoMobileID ? vimeoMobileID : vimeoID, width: window.innerWidth, loop: !0, background: !0, muted: !0 })),
                        video.classList.add("muted"),
                        Promise.all([vimeoInstance.getVideoWidth(), vimeoInstance.getVideoHeight()]).then(function (dimensions) {
                            var width = dimensions[0],
                                height = dimensions[1];
                            (videoAspectRatio = width / height),
                                vimeoInstance
                                    .play()
                                    .then(function (play2) {
                                        (videoPlaying = !0),
                                            setTimeout(() => {
                                                video.classList.add("playing");
                                            }, 1e3);
                                    })
                                    .catch(function (error) {
                                        switch (error.name) {
                                            case "NotAllowedError":
                                                console.log("cant autoplay");
                                                break;
                                            default:
                                                break;
                                        }
                                    }),
                                maintainAspectRatio(),
                                window.addEventListener("resize", debounce(maintainAspectRatio, 500));
                        });
                }
                function setfullScreen() {
                    vimeoInstance.requestFullscreen();
                }
                function toggleSound() {
                    (videoMuted = !videoMuted), vimeoInstance.setMuted(videoMuted), videoMuted ? video.classList.add("muted") : video.classList.remove("muted");
                }
                function toggleVideo() {
                    videoPlaying ? stopVideo() : playVideo();
                }
                function playVideo() {
                    (videoPlaying = !0), video.classList.add("playing"), vimeoInstance.play();
                }
                function stopVideo() {
                    (videoPlaying = !1), video.classList.remove("playing"), vimeoInstance.pause();
                }
                function maintainAspectRatio() {
                    var parentWidth = embed.parentNode.offsetWidth,
                        parentHeight = embed.parentNode.offsetHeight;
                    parentWidth > parentHeight * videoAspectRatio
                        ? ((embed.style.height = parentWidth / videoAspectRatio + "px"),
                          (embed.style.width = parentWidth + "px"),
                          (embed.style.marginLeft = "0"),
                          (embed.style.marginTop = (parentHeight - parentWidth / videoAspectRatio) / 2 + "px"))
                        : ((embed.style.height = parentHeight + "px"),
                          (embed.style.width = parentHeight * videoAspectRatio + "px"),
                          (embed.style.marginLeft = (parentWidth - parentHeight * videoAspectRatio) / 2 + "px"),
                          (embed.style.marginTop = "0"));
                }
                function debounce(func) {
                    var _arguments = arguments,
                        _this = this,
                        wait = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500,
                        immediate = arguments.length > 2 ? arguments[2] : void 0,
                        timeout;
                    return function () {
                        var context = _this,
                            args = _arguments,
                            later = function () {
                                (timeout = null), immediate || func.apply(context, args);
                            },
                            callNow = immediate && !timeout;
                        clearTimeout(timeout), (timeout = setTimeout(later, wait)), callNow && func.apply(context, args);
                    };
                }
            });
        }
        videoFuncInit();
    })(),
    (function () {
        function init() {
            var skipLinks = document.querySelectorAll(".js-access-skip"),
                skipLinksL = skipLinks.length,
                accessMode = !1;
            document.addEventListener("keyup", checkKeyEvent);
            for (var x2 = 0; x2 < skipLinksL; x2++) skipLinks[x2].addEventListener("keydown", skipToTarget);
            function checkKeyEvent(e) {
                (e.keyCode !== 9 && !accessMode) || ((accessMode = !0), document.body.classList.add("access"));
            }
            function clickEvent() {
                accessMode || ((accessMode = !1), document.body.classList.remove("access"));
            }
            function skipToTarget(e) {
                if (!(e.keyCode !== 13 && e.keyCode !== 32)) {
                    e.preventDefault();
                    var selector = e.target.getAttribute("data-next"),
                        target = document.querySelector(selector);
                    target.focus();
                }
            }
        }
        init();
    })(),
    (function () {
        function initNewsletter() {
            var newsletterform = document.querySelectorAll('.js-block[data-block="newsletter-form"]');
            newsletterform.forEach(function (formMod) {
                var newsletterform2 = formMod,
                    emailInput = newsletterform2.querySelector("#footer-newsletter-email"),
                    LIST_ID = "QfRKEE";
                newsletterform2.addEventListener("submit", submitForm);
                function submitForm(e) {
                    e.preventDefault();
                    var formData = { api_key: "250d2827bc1a3b4a60ee237328f854d2", profiles: [{ email: emailInput.value }] };
                    $.ajax({
                        type: "POST",
                        url: "https://a.klaviyo.com/api/v2/list/" + LIST_ID + "/subscribe",
                        data: formData,
                        processData: !0,
                        contentType: "application/json",
                        success: function (response) {
                            console.log(response);
                        },
                        dataType: "application/json",
                    });
                }
            });
        }
        initNewsletter();
    })(),
    (function () {
        function init() {
            var $daySelect = $("#register-dob-day"),
                $monthSelect = $("#register-dob-month"),
                $yearSelect = $("#register-dob-year"),
                $bdayInput = $("#birthday-date"),
                $bdayTag = $("#birthday-date-tag");
            function updateBday() {
                var day = $daySelect.val(),
                    month = $monthSelect.val(),
                    year = $yearSelect.val();
                day !== "day" &&
                    month !== "month" &&
                    year !== "year" &&
                    (day.length === 1 && (day = "0" + day.toString()),
                    month.length === 1 && (month = "0" + month.toString()),
                    $bdayInput.val(day.toString() + "/" + month.toString() + "/" + year.toString()),
                    $bdayTag.val("DOB:" + day.toString() + "/" + month.toString() + "/" + year.toString()));
            }
            $("#register-dob-day, #register-dob-month, #register-dob-year").on("change", function () {
                updateBday();
            });
        }
        $(document).ready(init);
    })(),
    (function () {
        function videoFuncInit() {
            var heroVideos = document.querySelectorAll('.js-block[data-block="hero-video"]');
            heroVideos.forEach(function (videoMod) {
                var heroVideo = videoMod,
                    vimeoID = heroVideo.getAttribute("data-id"),
                    vimeoMobileID = heroVideo.getAttribute("data-mobile-id"),
                    videoNative = heroVideo.getAttribute("data-video-native"),
                    embed = heroVideo.querySelector(".js-video-embed"),
                    sound = heroVideo.querySelector(".js-video-sound");
                if (vimeoID == 0 && !videoNative) return;
                var vimeoInstance = null,
                    nativeEl = null,
                    videoPlaying = !1,
                    videoMuted = !0,
                    videoAspectRatio = 0;
                vimeoID != 0 ? (createEmbed(), sound.addEventListener("click", toggleSoundVimeo)) : (registerNative(), sound.addEventListener("click", toggleSoundNative));
                function createEmbed() {
                    (vimeoInstance = new Vimeo.Player(embed, { controls: !1, id: window.innerWidth < 768 && vimeoMobileID ? vimeoMobileID : vimeoID, width: window.innerWidth, loop: !0, background: !0 })),
                        vimeoInstance.on("play", function () {
                            (videoPlaying = !0), heroVideo.setAttribute("data-playing", !0);
                        }),
                        Promise.all([vimeoInstance.getVideoWidth(), vimeoInstance.getVideoHeight()]).then(function (dimensions) {
                            var width = dimensions[0],
                                height = dimensions[1];
                            (videoAspectRatio = width / height), maintainAspectRatio(), window.addEventListener("resize", debounce(maintainAspectRatio, 200));
                        });
                }
                function registerNative() {
                    heroVideo.querySelectorAll(".video_native").forEach((el) => {
                        if ((console.debug("videoFunc.registerNative forEach", { el }), window.innerWidth < 768 && el.classList.contains("video_native_desktop"))) {
                            el.remove();
                            return;
                        } else if (window.innerWidth >= 768 && el.classList.contains("video_native_mobile")) {
                            el.remove();
                            return;
                        }
                        nativeEl = el;
                        const interval = setInterval(() => {
                            console.debug("videoFunc.registerNative interval", { nativeEl }),
                                nativeEl.videoWidth &&
                                    ((videoAspectRatio = nativeEl.videoWidth / nativeEl.videoHeight),
                                    maintainAspectRatio(),
                                    window.addEventListener("resize", debounce(maintainAspectRatio, 200)),
                                    (videoPlaying = !0),
                                    heroVideo.setAttribute("data-playing", !0),
                                    clearInterval(interval));
                        }, 100);
                    });
                }
                function toggleSoundVimeo() {
                    (videoMuted = !videoMuted), vimeoInstance.setMuted(videoMuted), videoMuted ? heroVideo.classList.add("muted") : heroVideo.classList.remove("muted");
                }
                function toggleSoundNative() {
                    (nativeEl.muted = !nativeEl.muted), nativeEl.muted ? heroVideo.classList.add("muted") : heroVideo.classList.remove("muted");
                }
                function maintainAspectRatio() {
                    var parentWidth = window.innerWidth,
                        parentHeight = window.innerHeight,
                        parentWidth = embed.parentNode.offsetWidth,
                        parentHeight = embed.parentNode.offsetHeight;
                    parentWidth > parentHeight * videoAspectRatio
                        ? ((embed.style.height = parentWidth / videoAspectRatio + "px"),
                          (embed.style.width = parentWidth + "px"),
                          (embed.style.marginLeft = "0"),
                          (embed.style.marginTop = (parentHeight - parentWidth / videoAspectRatio) / 2 + "px"))
                        : ((embed.style.height = parentHeight + "px"),
                          (embed.style.width = parentHeight * videoAspectRatio + "px"),
                          (embed.style.marginLeft = (parentWidth - parentHeight * videoAspectRatio) / 2 + "px"),
                          (embed.style.marginTop = "0"));
                }
                function debounce(func) {
                    var _arguments = arguments,
                        _this = this,
                        wait = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500,
                        immediate = arguments.length > 2 ? arguments[2] : void 0,
                        timeout;
                    return function () {
                        var context = _this,
                            args = _arguments,
                            later = function () {
                                (timeout = null), immediate || func.apply(context, args);
                            },
                            callNow = immediate && !timeout;
                        clearTimeout(timeout), (timeout = setTimeout(later, wait)), callNow && func.apply(context, args);
                    };
                }
            });
        }
        videoFuncInit();
    })(),
    (function () {
        function homeVideoFuncInit() {
            var homeHeros = document.querySelectorAll('.js-block[data-block="home-hero"]');
            homeHeros.forEach(function (videoMod) {
                var homeHero = videoMod,
                    width = 0;
                maintainAspectRatio(), window.addEventListener("resize", debounce(maintainAspectRatio, 200));
                function maintainAspectRatio() {
                    var newWidth = window.innerWidth,
                        newHeight = window.innerHeight;
                    if (newWidth > 1024) {
                        homeHero.style.removeProperty("height");
                        return;
                    }
                    newWidth === width || window.innerWidth < 768 || (console.log("did resize x1b"), (width = newWidth), (homeHero.style.height = newHeight + "px"));
                }
                function debounce(func) {
                    var _arguments = arguments,
                        _this = this,
                        wait = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500,
                        immediate = arguments.length > 2 ? arguments[2] : void 0,
                        timeout;
                    return function () {
                        var context = _this,
                            args = _arguments,
                            later = function () {
                                (timeout = null), immediate || func.apply(context, args);
                            },
                            callNow = immediate && !timeout;
                        clearTimeout(timeout), (timeout = setTimeout(later, wait)), callNow && func.apply(context, args);
                    };
                }
            });
        }
        homeVideoFuncInit();
    })(),
    (function () {
        gsap.registerPlugin(ScrollToPlugin);
        function initGallery() {
            var galleries = document.querySelectorAll('.js-block[data-block="desktop-gallery"]');
            galleries.forEach(function (galleryMod) {
                "use strict";
                for (
                    var gallery = galleryMod,
                        items = gallery.querySelectorAll(".pdp-gallery__gallery-item"),
                        itemsL = items.length,
                        thumbItems = gallery.querySelectorAll(".pdp-gallery__gallery-thumb a"),
                        current = 0,
                        setCurrentEvents = [],
                        x2 = 0;
                    x2 < itemsL;
                    x2++
                )
                    setCurrentEvents.push(setCurrent.bind(this, x2));
                for (var x2 = 0; x2 < itemsL; x2++) thumbItems[x2].addEventListener("click", setCurrentEvents[x2]);
                function setCurrent(x3, e) {
                    e.preventDefault(), gallery.setAttribute("data-current", x3);
                }
            });
        }
        initGallery();
    })(),
    (function () {
        function initMobilePDPBtns() {
            var btns = document.querySelectorAll('.js-block[data-block="mobile-pdp-btns"]');
            btns.forEach(function (btnsMod) {
                var wrap = btnsMod,
                    wrapInner = wrap.querySelector(".pdp-main__size-and-cart__inner"),
                    closeBtn = wrapInner.querySelector(".js-pdp-pricing-close-trigger"),
                    addToCartBtn = wrapInner.querySelector(".pdp-main__add-btn"),
                    sizeGuideBtn = wrapInner.querySelector(".js-size-guide-trigger"),
                    mainCols = document.querySelector(".pdp-main-cols"),
                    openBtn = document.querySelector(".js-pdp-select-size");
                shareBtn = mainCols.querySelector(".social-share-list button");
                var isActive = !1;
                openBtn && openBtn.addEventListener("click", open),
                    closeBtn && closeBtn.addEventListener("click", close),
                    wrap.addEventListener("click", close),
                    wrapInner.addEventListener("click", preventClose),
                    addToCartBtn.addEventListener("click", addtoCart),
                    sizeGuideBtn && sizeGuideBtn.addEventListener("click", showSizeGuide),
                    shareBtn && shareBtn.addEventListener("click", shareProduct);
                function open(e) {
                    e && e.target.className !== "btn klaviyo-bis-trigger" && e.preventDefault(), isActive || updatePage(!0);
                }
                function close(e) {
                    e && e.target.className !== "btn klaviyo-bis-trigger" && e.preventDefault(), isActive && updatePage(!1);
                }
                function preventClose(e) {
                    e && e.target.className !== "btn klaviyo-bis-trigger" && e.stopPropagation();
                }
                function showSizeGuide() {
                    close();
                }
                function addtoCart(e) {
                    addToCartBtn.getAttribute("disabled") || close();
                }
                function updatePage(newActiveState) {
                    (isActive = newActiveState), isActive ? document.body.classList.add("select-size-open") : document.body.classList.remove("select-size-open");
                }
                async function shareProduct(e) {
                    if (navigator && navigator.share)
                        try {
                            await navigator.share({ title: document.title, url: window.location });
                        } catch {
                            console.error("Share problem");
                        }
                }
            });
        }
        initMobilePDPBtns();
    })(),
    (function () {
        function homeSliderFuncInit() {
            var homeSlider = document.querySelectorAll('.js-block[data-block="home-slider"]');
            homeSlider.forEach(function (slideMod) {
                var homeSlide = slideMod,
                    width = 0;
                maintainAspectRatio(), window.addEventListener("resize", debounce(maintainAspectRatio, 200)), initSlide();
                function maintainAspectRatio() {
                    var newWidth = window.innerWidth,
                        newHeight = window.innerHeight;
                    if (newWidth > 1024) {
                        homeSlide.style.removeProperty("height");
                        return;
                    }
                    newWidth !== width && (console.log("did resize"), (width = newWidth), (homeSlide.style.height = newHeight + "px"));
                }
                function debounce(func) {
                    var _arguments = arguments,
                        _this = this,
                        wait = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500,
                        immediate = arguments.length > 2 ? arguments[2] : void 0,
                        timeout;
                    return function () {
                        var context = _this,
                            args = _arguments,
                            later = function () {
                                (timeout = null), immediate || func.apply(context, args);
                            },
                            callNow = immediate && !timeout;
                        clearTimeout(timeout), (timeout = setTimeout(later, wait)), callNow && func.apply(context, args);
                    };
                }
                function initSlide() {
                    var heroSlider = tns({ container: ".hero-slider", items: 1, mouseDrag: !0, controls: !1, navPosition: "bottom", speed: 800, autoplay: !0, autoplayTimeout: 5e3, autoplayButtonOutput: !1 });
                }
            });
        }
        homeSliderFuncInit();
    })(),
    (function () {
        const zoomContainier = document.querySelector(".product-gallery-zoom");
        zoomContainier &&
            (() => {
                $(".pdp-gallery__gallery-item img").on("click", function () {
                    $(zoomContainier).find("figure").removeClass("visible").removeClass("zoom"),
                        $(zoomContainier)
                            .find(`figure[data-id=${$(this).data("id")}]`)
                            .addClass("visible"),
                        $("body").attr("data-modal-open", !0).attr("data-gallery-zoom-open", !0),
                        $(zoomContainier).addClass("visible");
                }),
                    $(".pdp-gallery__gallery-item figure").on("mousemove", function (e) {
                        let zoomer = e.currentTarget;
                        zoomer.style.backgroundImage || (console.log(zoomer.style, zoomer.dataset), (zoomer.style.backgroundImage = `url('${zoomer.dataset.image}')`)),
                            e.offsetX ? (offsetX = e.offsetX) : (offsetX = e.touches[0].pageX),
                            e.offsetY ? (offsetY = e.offsetY) : (offsetX = e.touches[0].pageX),
                            (x = (offsetX / zoomer.offsetWidth) * 100),
                            (y = (offsetY / zoomer.offsetHeight) * 100),
                            (zoomer.style.backgroundPosition = `${x}% ${y}%`);
                    }),
                    $(".product-gallery-zoom-container figure").on("click", function () {
                        $(this).toggleClass("zoom");
                    }),
                    $(".product-gallery-zoom .close").on("click", function (e) {
                        $(zoomContainier).removeClass("visible"), $("body").attr("data-modal-open", !1).attr("data-gallery-zoom-open", !1);
                    }),
                    $(".product-gallery-zoom-container").on("click", function (e) {
                        e.target == this && ($(zoomContainier).removeClass("visible"), $("body").attr("data-modal-open", !1).attr("data-gallery-zoom-open", !1));
                    });
            })();
    })(),
    $(document).ready(function () {
        var sections = new slate.Sections();
        sections.register("product", theme.Product),
            slate.a11y.pageLinkFocus($(window.location.hash)),
            $(".in-page-link").on("click", function (evt) {
                slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
            });
        var tableSelectors = ".rte table";
        slate.rte.wrapTable({ $tables: $(tableSelectors), tableWrapperClass: "rte__table-wrapper" });
        var iframeSelectors = '.rte iframe[src*="youtube.com/embed"],.rte iframe[src*="player.vimeo"]';
        slate.rte.wrapIframe({ $iframes: $(iframeSelectors), iframeWrapperClass: "rte__video-wrapper" }),
            slate.cart.cookiesEnabled() && (document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies")),
            productImageLinks();
    });
function productImageLinks() {
    if ((console.log("productImageLinks"), $(".product-image-links").length && $(".product-image-links").attr("data-page") == 1)) {
        console.log("get URLS");
        let page = 2,
            size = $(".product-image-links").attr("data-size");
        for (; page <= size; )
            $.get("/collections/hidden-image-links?page=" + page, function (data) {
                $("#links").append($(data).find("#links").html());
            }),
                page++;
    }
}
function toggleQuickAddInput(that, productId) {
    const isPreorder = $(`#AddToCart-${productId}`).data("preorder");
    $(`#AddToCart-${productId}`)
        .attr("disabled", that.classList.contains("disabled"))
        .attr("data-quick-add-to-cart", that.dataset.variantId)
        .attr("data-lazy-selectors-option", that.dataset.variantId)
        .text(that.classList.contains("disabled") ? "SELECT SIZE" : isPreorder ? "PREORDER" : "ADD TO CART");
}
function closeSelectSizeModal() {
    $(".select-size-open").removeClass("select-size-open"), $(".collection-filters").show();
}
document.addEventListener("DOMContentLoaded", function () {
    $(".upsell__subproduct__radio").on("change", function (e) {
        const AddToCartId = e.target.dataset.addToCartButton,
            that = e.target;
        $(`#${AddToCartId}`).attr("disabled", that.classList.contains("disabled")).attr("data-quick-add-to-cart", that.dataset.variantId).attr("data-lazy-selectors-option", that.dataset.variantId);
    });
}),
    document.addEventListener("DOMContentLoaded", function () {
        setTimeout(function () {
            const inputElement = document.querySelector('div[data-testid="POPUP"] input');
            console.log("inputElement", inputElement),
                inputElement &&
                    inputElement.addEventListener("focusout", function () {
                        const alertSpan = document.querySelector('div[data-testid="POPUP"] span[role="alert"]');
                        (alertSpan.parentElement.parentElement.style = { position: "relative", background: "transparent" }), (alertSpan.parentElement.style = { border: "none" });
                    });
        }, 5e3);
    });
//# sourceMappingURL=/cdn/shop/t/441/assets/theme.js.map?v=10443420193048215801724715825
